// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:12:38.997Z
// Property: Windsor Estates (ID: 6737460151192631)
// Collections: 48 amenities, 8 floorplans (live), 45 photos, 89 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192631",
  "property_external_id": "4709057",
  "property_zillow_url": "TBD",
  "property_apartments_url": "https://www.apartments.com/windsor-estates-texas-city-tx/ege7dcp",
  "property_google_business_url": "https://www.google.com/maps/place/Windsor+Estates/data=!4m2!3m1!1s0x0:0x5d12701553bef836?sa=X&ved=2ahUKEwijxazpx7ySAxURYEEAHTn1HLYQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321132575",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "windsor-estates",
  "property_name": "Windsor Estates",
  "property_website_url": "https://www.windsorestatesapthome.com/",
  "property_domain": "https://www.windsorestatesapthome.com/",
  "property_address": "2801 Fm 2004 Rd",
  "property_full_address": "2801 FM 2004, Texas City, TX 77591",
  "property_address_1": "2801 FM 2004",
  "property_address_2": null,
  "property_address_city": "Texas City",
  "property_address_state": "TX",
  "property_address_zip_full": "77591-9163",
  "property_address_zip": "77591",
  "property_address_country": "US",
  "property_address_county": "Galveston County",
  "property_neighborhood_address": "South Galveston County",
  "property_address_latitude": "29.4094607",
  "property_address_longitude": "-95.0332007",
  "property_email": "windsorestates@rreafresidential.com",
  "property_phone": "(409) 986-5966",
  "property_call_tracking_phone": "409-377-6943",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Windsor Estates in Texas City, TX, where comfort meets convenience! Choose from our spacious one, two, and three-bedroom floor plans, and enjoy exceptional amenities like a pool, fitness center, and a dog park. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "Welcome to Windsor Estates, your ideal apartment community located in the heart of Texas City, TX. With a range of thoughtfully designed floor plans, including one-, two-, and three-bedroom apartments, we cater to every lifestyle and family size. Each residence is upgraded for your comfort and convenience, making it the perfect place to call home.\n\nAt Windsor Estates, we pride ourselves on our exceptional amenities that enhance your living experience. Enjoy peace of mind with our night patrol and on-site management, ensuring a safe and secure environment. Dive into relaxation at our inviting pool, or socialize with friends in the TV lounge or clubhouse. Stay active at our state-of-the-art fitness center or play a friendly game at the volleyball court. Our community also features a dog park for your furry friends, covered parking, and a dedicated car wash area for your convenience.\n\nTake advantage of our business center and laundry facilities, making everyday tasks a breeze. Need something repaired? Our prompt on-site maintenance team is always just a call away. \n\nWindsor Estates proudly stands as a price leader in the area, providing fantastic living spaces without sacrificing quality. Experience modern living with our upgraded features and exceptional service. \n\nFind your new home today at Windsor Estates! Browse our availability or schedule a tour to visit our vibrant community. Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-d543-758d-ab71-1cacfe222768.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
    "public_id": "019e8497-d543-758d-ab71-1cacfe222768",
    "storage_key": "property/6737460151192631/019e8497-d543-758d-ab71-1cacfe222768.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "400",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.75",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://windsorestates.loftliving.com/login",
  "property_apply_now_url": "https://8451242.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-11dd-709f-b0ca-5e95f80bc754.webp",
  "property_primary_logo_media": {
    "alt_text": "Windsor Estates Apartment Homes logo",
    "public_id": "019e8497-11dd-709f-b0ca-5e95f80bc754",
    "storage_key": "property/6737460151192631/019e8497-11dd-709f-b0ca-5e95f80bc754.webp",
    "width": 3072,
    "height": 1239
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-11dd-709f-b0ca-5e95f80bc754.webp",
  "property_secondary_logo_media": {
    "alt_text": "Windsor Estates Apartment Homes logo",
    "public_id": "019e8497-11dd-709f-b0ca-5e95f80bc754",
    "storage_key": "property/6737460151192631/019e8497-11dd-709f-b0ca-5e95f80bc754.webp",
    "width": 3072,
    "height": 1239
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8e87-1db0-76da-87a3-01cd883fe9bd.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-1db0-76da-87a3-01cd883fe9bd",
    "storage_key": "property/6737460151192631/019e8e87-1db0-76da-87a3-01cd883fe9bd.webp",
    "width": 1280,
    "height": 516
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8e87-110b-716e-8ca7-4a826cb020b4.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-110b-716e-8ca7-4a826cb020b4",
    "storage_key": "property/6737460151192631/019e8e87-110b-716e-8ca7-4a826cb020b4.webp",
    "width": 1280,
    "height": 516
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#84a0bd",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "727 - 1375",
  "property_sqft_min": "727",
  "property_sqft_max": "1375",
  "property_price_range": "1843",
  "property_price_min": null,
  "property_price_max": "1843",
  "property_available_units": 29,
  "property_facebook_url": "https://www.facebook.com/WindsorEstatesApartments/",
  "property_instagram_url": "https://www.instagram.com/windsorestates_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJHSxGTnF-P4YRNvi-UxVwEl0",
  "property_youtube_url": "https://www.youtube.com/watch?t=109&v=BVVRLZLb3kU",
  "property_yelp_url": "https://www.yelp.com/biz/windsor-estates-apartments-texas-city-2",
  "property_tiktok_url": "https://www.tiktok.com/@windsor.estates",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Windsor Estates",
  "property_home_romance_title": "Embrace a Charming Life at Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Welcome to pet-friendly Windsor Estates, the most desirable luxury apartment homes in Texas City, Texas! Located just off Interstate 45, your commute to fine dining, shopping, parks, and entertainment is just minutes away. Every convenience you need is close to home. Discover the <a href=\"/gallery/\">best-kept secret</a> in Galveston county.</p>",
  "property_home_floorplans_blurb": "<p>Texas City is a scenic locale located along the southwestern shoreline of Galveston Bay. Living in the Texas Gulf Coast provides <a href=\"/floor-plans/\">residents</a> with ample opportunity to enjoy the outdoors, whether it's local parks like Rainbow Park or Galveston Beach, which is just 14 miles south of Texas City. The city also offers easy access to Houston, which is just 40 miles away. Along with beach trips and watersports, Texas City has 5Ks, art festivals, and other special events throughout the year.</p>",
  "property_home_gallery_blurb": "At Windsor Estates in Texas City, TX, your perfect home awaits! Choose from spacious one, two, or three-bedroom floor plans featuring modern amenities like a fitness center, pool, and clubhouse. Enjoy carefree living with controlled access, on-site maintenance, and vibrant planned activities. Picture yourself living here! ",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Windsor Estates in Texas City, TX! Explore our spacious one, two, and three-bedroom floor plans, perfect for any lifestyle. See what's around our community and uncover local favorites and nearby points of interest that enhance your living experience. Join us today!",
  "property_home_reviews_blurb": "At Windsor Estates, our residents wholeheartedly agree: this is a standout community in Texas City, where friendly staff and incredible amenities shine. With one happy resident stating, “Everyone in the office is nice and helpful,” it's clear we prioritize exceptional service. Join us in experiencing the warmth and luxury of your new home!",
  "property_neighborhood_blurb": "<p>Texas City is a scenic locale located along the southwestern shoreline of Galveston Bay. Living in the Texas Gulf Coast provides <a href=\"/floor-plans/\">residents</a> with ample opportunity to enjoy the outdoors, whether it's local parks like Rainbow Park or Galveston Beach, which is just 14 miles south of Texas City. The city also offers easy access to Houston, which is just 40 miles away. Along with beach trips and watersports, Texas City has 5Ks, art festivals, and other special events throughout the year.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Welcome to the pet-friendly Windsor Estates apartment homes in stellar Texas City, TX! You can live life to the fullest here by taking a dip in one of our shimmering swimming pools, playing a game on the volleyball court, or exercising in the fully equipped state-of-the-art fitness center. We have <a href=\"/floor-plans/\">apartments for rent</a> loaded with options, including 9-foot vaulted ceilings.</p>",
  "property_applynow_blurb": "Discover your perfect home at Windsor Estates in Texas City, TX! Choose from spacious one, two, or three-bedroom floor plans, and enjoy top-notch amenities like a fitness center, pool, and dog park. Experience the convenience of on-site management and upgraded features. Find your new home and lease online today!",
  "property_contactus_blurb": "Discover your ideal living space at Windsor Estates in Texas City, TX. We offer a variety of floor plans, including stylish one, two, and three-bedroom apartments designed to suit your lifestyle. Have questions? Contact our leasing team today to learn more about your future home!",
  "property_faqs_blurb": "Discover your ideal home at Windsor Estates in Texas City, TX, featuring spacious one, two, and three-bedroom floor plans. Have questions? Browse our FAQs page to get insightful answers about our vibrant community and find out why Windsor Estates is the perfect place for you to live.",
  "property_floorplans_blurb": "<p>Windsor Estates offers twelve spacious floor plans with one, two, or three-bedroom apartments for rent. Each home is custom-made just for you, featuring resurfaced countertops, plank hardwood floors, and decorative lighting. Never run out of room with extra storage space. <a href=\"/amenities/\">We love your pets</a>, too, which is why we have free pet treats!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at Windsor Estates in Texas City, TX! Choose from spacious one, two, and three-bedroom floor plans, complete with top-notch amenities like a pool, fitness center, dog park, and more. Explore our interactive community map now to view availability and pricing for your ideal apartment!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover your ideal home at Windsor Estates in Texas City, TX! Choose from spacious one, two, and three-bedroom floor plans designed for comfort and style. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the perks of living together! View all floor plans now!",
  "property_residentaccess_blurb": "Welcome to Windsor Estates in Texas City, TX! Explore our diverse floor plans featuring one, two, and three-bedroom apartments tailored to your lifestyle. Access your resident portal to conveniently pay rent, schedule maintenance, and more. Experience comfortable living at Windsor Estates—your perfect home awaits!",
  "property_reviews_blurb": "At Windsor Estates in Texas City, TX, residents rave about the attentive staff and stunning amenities, creating a vibrant community atmosphere. One resident notes, \"The office staff and maintenance team are super professional and very attentive,\" highlighting the exceptional service that makes every stay enjoyable. Come find your perfect home!",
  "property_created_at": "1752257254781",
  "property_scheduletour_blurb": "Discover your ideal home at Windsor Estates in Texas City, TX! Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Don’t just take our word for it—schedule a tour today and see what our residents have to say about living in this vibrant community!",
  "property_thankyou_blurb": "Thank you for submitting your information about Windsor Estates in Texas City, TX! Explore our thoughtfully designed floor plans, featuring one, two, and three-bedroom layouts. Our friendly team will reach out shortly to assist you in finding your perfect home. Stay tuned for exciting updates on your future apartment!",
  "property_virtualtours_blurb": "<p>At Windsor Estates, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Windsor Estates",
  "property_seo_title_home": "Windsor Estates | Apartments in Texas City, TX",
  "property_seo_description_home": "Discover your perfect home at Windsor Estates in Texas City, TX! Choose from a variety of floor plans, including one, two, and three-bedroom apartments. Enjoy top-notch amenities like a refreshing pool, state-of-the-art fitness center, dog park, and clubhouse. With 24/7 night patrol, on-site management, and maintenance, your comfort and security are our priorities. Explore our upgraded units and take advantage of covered parking, a business center, and more. Don’t wait, find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Texas City, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Windsor Estates in Texas City, TX! Explore our diverse floor plans featuring one, two, and three-bedroom apartments designed for comfort and style. Browse our available apartment homes and find your perfect floor plan today!",
  "property_seo_title_amenities": "Amenities | Texas City, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover the vibrant lifestyle at Windsor Estates in Texas City, TX! Choose from spacious one, two, or three-bedroom floor plans designed for comfort. Enjoy exceptional amenities including a refreshing pool, modern fitness center, dog park, and a welcoming clubhouse. With on-site management, night patrol, and 24/7 maintenance, your peace of mind is our priority. Explore our amazing community amenities and apartment features today—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Texas City, TX",
  "property_seo_description_gallery": "Explore Windsor Estates in Texas City, TX—your new home awaits! Discover our spacious floor plans, featuring one, two, and three-bedroom apartments designed for comfort and style. Enjoy exceptional amenities like a refreshing pool, state-of-the-art fitness center, dog park, and clubhouse. Experience peace of mind with on-site management, night patrol, and maintenance. Don’t just imagine living here; picture it! Check out our photo gallery and start your journey to a vibrant community lifestyle today.",
  "property_seo_title_virtualtours": "Virtual Tours | Windsor Estates Apartments",
  "property_seo_description_virtualtours": "\"Explore Windsor Estates in Texas City, TX! Take a virtual tour of our stunning one, two, and three-bedroom apartments available for rent. Discover your perfect floor plan and experience the vibrant community that awaits you. Don’t miss out – start your journey home today!\"",
  "property_seo_title_interactivemap": "Interactive Map | Windsor Estates Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at Windsor Estates in Texas City, TX! Explore our diverse range of floor plans, from cozy one-bedroom to spacious three-bedroom apartments. Enjoy top-notch amenities including a pool, fitness center, and dog park, all overseen by on-site management and night patrol for your peace of mind. Use our interactive community map to search available apartments, view pricing, and select your new home today! Experience upgraded living at Texas City’s price leader.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Texas City, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Windsor Estates in Texas City, TX! Explore our one, two, and three-bedroom apartments, and see what's around our community. From local favorites to exciting points of interest, immerse yourself in the lifestyle that awaits you. Start your journey today!",
  "property_seo_title_contact": "Contact Us | Windsor Estates",
  "property_seo_description_contact": "Discover your ideal home at Windsor Estates in Texas City, TX! With expertly designed one, two, and three-bedroom floor plans, we have the perfect space for everyone. Have questions? Our friendly leasing team is ready to assist you—contact us today and take the first step towards your new apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in Texas City, TX",
  "property_seo_description_faqs": "Discover everything you need to know about Windsor Estates in Texas City, TX! Our FAQs page covers essential topics, from floor plans—like our spacious one, two, and three-bedroom apartments—to top-notch amenities such as a sparkling pool, fitness center, dog park, and more. With on-site management and maintenance, you can rest easy knowing we’ve got you covered. Browse our FAQs today to find answers that will help you choose your perfect home at Windsor Estates!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Texas City, TX",
  "property_seo_description_reviews": "\"Discover the vibrant lifestyle at Windsor Estates in Texas City, TX, where our one, two, and three-bedroom apartments offer spacious living tailored for you. Enjoy exclusive amenities including a pool, fitness center, dog park, and more! Curious what our community feels about their home? See what our residents have to say about living at Windsor Estates!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Texas City, TX",
  "property_seo_description_applynow": "Discover your ideal living space at Windsor Estates in Texas City, TX! Choose from one, two, or three-bedroom apartment floor plans that cater to your lifestyle. Enjoy premium amenities like a refreshing pool, fitness center, and dog park, along with convenient features like on-site management and 24-hour night patrol for peace of mind. With upgraded living options and a price leader advantage, we are committed to providing a comfortable and vibrant community. Ready to make the move? Apply now and find your new home—lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Windsor Estates",
  "property_seo_description_residentaccess": "\"Welcome to Windsor Estates in Texas City, TX! Log in to your resident portal for easy rent payments, maintenance requests, and exclusive community updates. Access your resident benefits today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Windsor Estates",
  "property_seo_description_referafriend": "\"Spread the word about Windsor Estates in Texas City, TX! Refer a friend to our vibrant apartment community and enjoy rewards together. Great friends make great neighbors - share the love and create lasting memories. Start referring today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Windsor Estates",
  "property_seo_description_scheduletour": "\"Experience the charm of Windsor Estates in Texas City, TX! Schedule a tour today to explore our beautiful apartment community, featuring modern amenities and a welcoming atmosphere. Discover your future home!\"",
  "property_seo_title_privacy": "Privacy Policy | Windsor Estates",
  "property_seo_description_privacy": "\"Discover peace of mind at Windsor Estates in Texas City, TX. Our privacy policy is designed to safeguard your personal information while you enjoy our community. View our privacy policy now to learn more about how we protect your data!\"",
  "property_seo_title_accessibility": "Website Accessibility | Windsor Estates",
  "property_seo_description_accessibility": "\"Discover how Windsor Estates in Texas City, TX, is committed to digital inclusion with our comprehensive accessibility statement. We value every resident's experience and ensure our online resources are user-friendly for all. Learn more about our commitment to accessibility today!\"",
  "property_seo_title_sitemap": "Sitemap | Windsor Estates",
  "property_seo_description_sitemap": "Explore Windsor Estates in Texas City, TX! Our comprehensive sitemap makes it easy to navigate our vibrant apartment community. Discover amenities, floor plans, and more. View our website sitemap today for a seamless experience!",
  "property_seo_title_thankyou": "Thank You | Windsor Estates",
  "property_seo_description_thankyou": "Thank you for reaching out to Windsor Estates in Texas City, TX! Your inquiry is important to us. A member of our team will be in touch shortly to assist you in discovering your new home. Stay tuned for updates and get ready to experience the comfort and community at Windsor Estates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Texas City, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293647779",
  "amenities": [
    {
      "id": "custom_160aafab-bf65-4958-a22c-cecb943b3b5a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Two Shimmering Swimming Pools with Outdoor Lounge and Grilling Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_74c370e8-1b1e-40b8-a30b-9a744e1c8acb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park with Agility Course",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fb35803c-76a5-411e-b748-aa4bd6b0eb2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc77fe98-29ba-4e85-8895-f46ece00fc17",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Social Terrace with Picnic Tables and Barbecue",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aeee93a7-55f8-4300-bcf3-b6a17d7e0a77",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Auto Detailing Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e06e363-9cf4-40f0-94f1-9e4eacfc7ae7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3d35c41f-64a9-4c15-a8b5-795ecd11e5f8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_530caca9-97c6-4030-a744-d80e277a15fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Common Area Laundry Facility",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4a037b0-7831-4ad3-a04a-46a8241db53d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Door‑to‑Door Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d049ac7-8f8e-468f-a31e-e88076db671a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Greenery and Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9d32eb78-8c04-405b-8ba2-94b36e5f9704",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Walking Paths",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4dc1986-cfcd-480a-8e08-246f23a46fc2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Corporate Housing Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6dd62f51-f089-4cc7-be99-a29f2efd1667",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f543e604-cce1-4f1f-beca-10f0405cf720",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Private Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c21c07bf-9e7c-46f0-91bb-967a5d4aa2cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2d66f4e-f9f4-49a7-97a2-ddfcb6eedeb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5455edb8-67df-4088-b681-470903b47495",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4203fd79-d08f-4858-be9a-a16c720ffe94",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9829fb0a-3a79-4a90-ad15-39f732d5f7ac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e666366f-79da-44f1-adc7-eafb6c911b37",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_70374554-ad05-447a-86bf-4fd8b2821bb9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Maintenance with 24‑hour Emergency Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7059315d-9184-45aa-af7f-fe3764d08480",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7a6ef2c7-b042-4c7a-8634-ca93220f58f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Leasing Terms",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3cd3886-17cd-4cb4-9c70-18f68a262ef9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse with Business Center, Conference Room, and Free WIFI",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00c19588-53bf-48a4-ab9b-92cf9f073771",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Conveniently Located Near Public Transportation, Freeways, Shopping, and Restaurants",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dcda9873-c10b-4e62-b87f-3a24dad9fb5f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "9‑foot Ceilings with Vaulted Ceilings Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0be55c5b-bace-4c7e-a0d3-6f776eb82620",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Efficient, Modern Black Appliance Package with Built‑In Microwave in Kitchen*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d90289da-3cc7-4c26-b212-95e31f741d2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Countertops and White Cabinets in Kitchen and Bathrooms*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d3a6a10-dd31-45fb-9aa7-002948ed0ddd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Chef‑Ready Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7923ed06-a3d1-4abc-be0f-0116e11b3eb6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑vinyl and Carpeted Floors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_83049da2-1bc4-4ec8-a995-e38a0d15fea5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans with Decorative Light Kits in Living Areas and Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_745d1841-5a9a-42b9-9832-5fee43f8e554",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Homes with Modern LED Lighting*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c4e8ddd-a13d-479e-94b9-6deccc0f88ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Coat Closet for Additional Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f12ba3e3-f67b-4136-af23-79d434bf574d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Built‑In Bookshelf",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ce307ad-0b69-43a2-b79e-e6e2e0cdb0fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_372bd642-0631-4c8b-857f-53af048c5071",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Garden‑Style Soaking Tubs with Curved Shower Rods",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e328d8d0-8ff6-40fd-927d-b2db6d057e6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑Sized Washer and Dryer*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eec5d985-8915-4422-a899-e8a42e024b29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_edb6e9eb-7577-4ff0-9585-2782a4320b1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Gooseneck Faucet*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_04904ce9-f7f3-4a89-9e38-d7bc636036db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "2” Faux Wood Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59e752ce-be01-4452-a88e-f602d22fbe2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios and Balconies with Additional Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ccbc665-381a-4b20-b4c5-a52527d57179",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "High‑Speed Internet Access and Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_47bb6772-c55b-4422-986e-6eff3878671b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Desirable Views Available*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02c628f0-2664-41f3-ad1f-2a0cf4efdff5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e15cda15-f2a7-4c28-8b85-45f703313366",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae6291c3-e913-48fe-9736-b6a1b6ed714e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Shaker-Style Cabinet Fronts with Black Cabinet Pulls*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e76191a2-3134-4386-954a-8ef148846bbe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliance Package*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3103862b-a60d-466b-a29c-a6edefffc9a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "external_id": "false",
      "title": "Black Hardware and Light Package*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2bb25814-b83c-4978-a62e-3c593d2e17db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/01a0f84c-1188-77c3-9260-98273a7d82f0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "01a0f84c-1188-77c3-9260-98273a7d82f0",
        "storage_key": "property/6737460151192631/01a0f84c-1188-77c3-9260-98273a7d82f0.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind by our beautiful resort-style swimming pool. Enjoy the sun on our comfortable lounge chairs or take a refreshing dip in the sparkling blue water.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_939ef511-c041-4f94-99a1-8552ac543d86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/01a0f84c-0fd7-74dc-b52d-4a61ad3ab52e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a0f84c-0fd7-74dc-b52d-4a61ad3ab52e",
        "storage_key": "property/6737460151192631/01a0f84c-0fd7-74dc-b52d-4a61ad3ab52e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style swimming pool, complete with comfortable lounge chairs and refreshing umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e7999a8d-c292-44d8-9e9a-e977853f101d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-d543-758d-ab71-1cacfe222768.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
        "public_id": "019e8497-d543-758d-ab71-1cacfe222768",
        "storage_key": "property/6737460151192631/019e8497-d543-758d-ab71-1cacfe222768.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool and soothing hot tub, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1efb6b52-df3d-4bb7-a204-d1ec64837646",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-080d-753d-b2b7-0a81dfc9b384.webp",
      "image_media": {
        "alt_text": "Living room with two blue armchairs, a beige sofa, and a coffee table.",
        "public_id": "019faeb7-080d-753d-b2b7-0a81dfc9b384",
        "storage_key": "property/6737460151192631/019faeb7-080d-753d-b2b7-0a81dfc9b384.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring plush seating, a modern coffee table, and large windows with a view of the community grounds.",
      "link": "",
      "alt_text": "Living room with two blue armchairs, a beige sofa, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1957ec04-d8ce-4d83-a186-85f00167320d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-0c65-760d-98f4-211a63d6fe99.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances and white cabinets",
        "public_id": "019faeb7-0c65-760d-98f4-211a63d6fe99",
        "storage_key": "property/6737460151192631/019faeb7-0c65-760d-98f4-211a63d6fe99.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring black appliances, white cabinets, and a spacious layout. Includes a laundry room with washer and dryer.",
      "link": "",
      "alt_text": "Kitchen with black appliances and white cabinets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6aa5803-d4d4-456b-bd86-d959564913bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-0808-76da-9935-735e8c77f3c9.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment with blue chairs and a glass table.",
        "public_id": "019faeb7-0808-76da-9935-735e8c77f3c9",
        "storage_key": "property/6737460151192631/019faeb7-0808-76da-9935-735e8c77f3c9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, adjacent to a modern kitchen featuring sleek appliances and ample counter space.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment with blue chairs and a glass table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b3f6e89-fbb7-48d9-8cf5-14ada0b31457",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-0c12-779c-9f86-aed7b1a07cba.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019faeb7-0c12-779c-9f86-aed7b1a07cba",
        "storage_key": "property/6737460151192631/019faeb7-0c12-779c-9f86-aed7b1a07cba.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a comprehensive workout in our fully equipped fitness center, featuring a wide array of cardio and strength training equipment to meet all your fitness needs.",
      "link": "",
      "alt_text": "State-of-the-art fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d771729a-67d0-4337-af34-43beb9c7c316",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-0c17-7739-970d-f8add914514b.webp",
      "image_media": {
        "alt_text": "Interior common area with dining table, sofa, and kitchen area.",
        "public_id": "019faeb7-0c17-7739-970d-f8add914514b",
        "storage_key": "property/6737460151192631/019faeb7-0c17-7739-970d-f8add914514b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy the spacious common area, featuring a dining table, a comfortable sofa, and a convenient kitchen area for residents and guests.",
      "link": "",
      "alt_text": "Interior common area with dining table, sofa, and kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_adc30851-ebdf-4750-8ad4-5970baff168d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/01a0f84c-0fda-71ee-aa6e-c2f7749afc02.webp",
      "image_media": {
        "alt_text": "Outdoor seating area under a blue shade canopy with a sofa, chairs, and coffee table.",
        "public_id": "01a0f84c-0fda-71ee-aa6e-c2f7749afc02",
        "storage_key": "property/6737460151192631/01a0f84c-0fda-71ee-aa6e-c2f7749afc02.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor seating area, perfect for enjoying the fresh air and sunshine.",
      "link": "",
      "alt_text": "Outdoor seating area under a blue shade canopy with a sofa, chairs, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fae6d766-3c67-4504-8e79-16914b9157f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8496-f2ca-76dc-8887-c5352d7ac3e3.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick accents and manicured lawns.",
        "public_id": "019e8496-f2ca-76dc-8887-c5352d7ac3e3",
        "storage_key": "property/6737460151192631/019e8496-f2ca-76dc-8887-c5352d7ac3e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings featuring a blend of brick and siding, surrounded by lush green lawns and walking paths.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick accents and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_17e7727e-292a-4f0d-a953-92b7f2de3306",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-0c09-72cb-8f36-d4d7b22bda03.webp",
      "image_media": {
        "alt_text": "Business center with computers, printers, and seating areas.",
        "public_id": "019faeb7-0c09-72cb-8f36-d4d7b22bda03",
        "storage_key": "property/6737460151192631/019faeb7-0c09-72cb-8f36-d4d7b22bda03.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay connected and productive in our resident business center, equipped with computers and printers for your convenience.",
      "link": "",
      "alt_text": "Business center with computers, printers, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86ad0858-facc-490d-a4f9-d726b7f53d1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-0c1d-777f-a789-86ede2a3cddc.webp",
      "image_media": {
        "alt_text": "View of a bedroom with a king-size bed and an open doorway to a bathroom.",
        "public_id": "019faeb7-0c1d-777f-a789-86ede2a3cddc",
        "storage_key": "property/6737460151192631/019faeb7-0c1d-777f-a789-86ede2a3cddc.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable king-size bed and tasteful artwork, with an adjacent bathroom offering modern fixtures.",
      "link": "",
      "alt_text": "View of a bedroom with a king-size bed and an open doorway to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a61bf6c-4c9b-45e6-8b6c-e6e29b1778b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-9016-72f2-a11d-e740a9776119.webp",
      "image_media": {
        "alt_text": "Large outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019e8497-9016-72f2-a11d-e740a9776119",
        "storage_key": "property/6737460151192631/019e8497-9016-72f2-a11d-e740a9776119.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our spacious outdoor swimming pool, perfect for relaxing and unwinding under the sun. Surrounded by lush landscaping and comfortable seating, it's the ideal spot for residents to escape the heat and socialize.",
      "link": "",
      "alt_text": "Large outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f5517d2-1ebc-4d33-88dd-1b9f771c9d37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-080c-746a-8113-0d245a79a4b9.webp",
      "image_media": {
        "alt_text": "Living room and dining area with blue chairs and a glass table.",
        "public_id": "019faeb7-080c-746a-8113-0d245a79a4b9",
        "storage_key": "property/6737460151192631/019faeb7-080c-746a-8113-0d245a79a4b9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Cozy living and dining area featuring blue upholstered chairs around a glass-top dining table, with a comfortable sofa and wall-mounted TV in the background.",
      "link": "",
      "alt_text": "Living room and dining area with blue chairs and a glass table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5bf64009-f9eb-45eb-8d2c-cdf4cd12ffa0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-080a-760f-b135-f455f6f4fa43.webp",
      "image_media": {
        "alt_text": "Bedroom with dresser, closet, and en-suite bathroom access.",
        "public_id": "019faeb7-080a-760f-b135-f455f6f4fa43",
        "storage_key": "property/6737460151192631/019faeb7-080a-760f-b135-f455f6f4fa43.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a modern dresser, convenient closet, and a beautifully appointed en-suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with dresser, closet, and en-suite bathroom access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51a8aae0-230d-4dcd-937f-6f9c5f63c06b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-f932-753d-9a99-e49e30ad4975.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinetry.",
        "public_id": "019e8497-f932-753d-9a99-e49e30ad4975",
        "storage_key": "property/6737460151192631/019e8497-f932-753d-9a99-e49e30ad4975.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen, complete with black appliances, ample cabinet space, and a convenient layout.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66b4b7f6-3f6e-40e8-aee5-c9dc348c3dbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8498-02c8-7338-a965-b71425459b5a.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with large windows and hardwood floors.",
        "public_id": "019e8498-02c8-7338-a965-b71425459b5a",
        "storage_key": "property/6737460151192631/019e8498-02c8-7338-a965-b71425459b5a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious living room and open-concept kitchen featuring ample natural light, hardwood flooring, and modern finishes. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with large windows and hardwood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4aff8499-7294-41b3-9210-786a7c20dca7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8498-02b3-77be-a161-ae9b7f2c35fd.webp",
      "image_media": {
        "alt_text": "Open concept living area with a kitchen island and view into the kitchen and hallway.",
        "public_id": "019e8498-02b3-77be-a161-ae9b7f2c35fd",
        "storage_key": "property/6737460151192631/019e8498-02b3-77be-a161-ae9b7f2c35fd.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area with a modern kitchen, perfect for entertaining. Enjoy the convenience of a breakfast bar and ample natural light.",
      "link": "",
      "alt_text": "Open concept living area with a kitchen island and view into the kitchen and hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d32e781c-3599-4a15-bbf9-6a96aa663e86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-25d9-7263-938f-2fcc7a33d6f1.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and recumbent bikes.",
        "public_id": "019e8497-25d9-7263-938f-2fcc7a33d6f1",
        "storage_key": "property/6737460151192631/019e8497-25d9-7263-938f-2fcc7a33d6f1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio equipment and weight machines.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, and recumbent bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0dcee5e8-c708-47c2-8548-7a2d3d383f7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-bfb7-76ac-9493-0041b6469895.webp",
      "image_media": {
        "alt_text": "A fenced dog park with agility equipment like tunnels and jumps.",
        "public_id": "019e8497-bfb7-76ac-9493-0041b6469895",
        "storage_key": "property/6737460151192631/019e8497-bfb7-76ac-9493-0041b6469895.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Let your furry friends play freely in our dedicated dog park, complete with fun agility equipment for them to enjoy.",
      "link": "",
      "alt_text": "A fenced dog park with agility equipment like tunnels and jumps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0686bb57-1cf4-4c60-a2a3-5ba1ebe84c58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-faf3-715a-a546-0d324f001ee7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and light wood floors.",
        "public_id": "019e8497-faf3-715a-a546-0d324f001ee7",
        "storage_key": "property/6737460151192631/019e8497-faf3-715a-a546-0d324f001ee7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen, featuring sleek black appliances, ample cabinet space, and modern finishes.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances, white cabinets, and light wood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_feb91aa7-1384-43b2-8078-0c80e5ea58ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019faeb7-081d-7108-9d69-e9f4ac0be05f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, and a blue gradient shower curtain.",
        "public_id": "019faeb7-081d-7108-9d69-e9f4ac0be05f",
        "storage_key": "property/6737460151192631/019faeb7-081d-7108-9d69-e9f4ac0be05f.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this updated apartment bathroom, featuring a spacious vanity, modern fixtures, and a chic blue gradient shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, sink, and a blue gradient shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e1007e9-e3fe-4e23-959d-cadd8bd67665",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-ffe8-74dd-9f3b-78ad273b8cf9.webp",
      "image_media": {
        "alt_text": "Living room and entrance to an apartment",
        "public_id": "019e8497-ffe8-74dd-9f3b-78ad273b8cf9",
        "storage_key": "property/6737460151192631/019e8497-ffe8-74dd-9f3b-78ad273b8cf9.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious living room with wood-look flooring and a view of the apartment entrance and a hallway. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room and entrance to an apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80809666-3305-44d0-98a9-ee99132e3da0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-f644-732a-a02b-26d286eca149.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and en-suite bathroom",
        "public_id": "019e8497-f644-732a-a02b-26d286eca149",
        "storage_key": "property/6737460151192631/019e8497-f644-732a-a02b-26d286eca149.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet and an en-suite bathroom for ultimate convenience.",
      "link": "",
      "alt_text": "Bedroom with closet and en-suite bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_79b0bcb0-8f33-4fb6-93fc-93ff6b8976c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-f625-74ad-8c2f-fe3abf4d4e15.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and access to closet and bathroom.",
        "public_id": "019e8497-f625-74ad-8c2f-fe3abf4d4e15",
        "storage_key": "property/6737460151192631/019e8497-f625-74ad-8c2f-fe3abf4d4e15.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a ceiling fan, walk-in closet, and an en-suite bathroom. Perfect for comfortable living.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and access to closet and bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a091f680-45b9-4d51-974e-5d4d3b59769a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-e551-7419-b8a4-684eb9484cfb.webp",
      "image_media": {
        "alt_text": "A modern bathroom with a bathtub, toilet, and vanity with a sink.",
        "public_id": "019e8497-e551-7419-b8a4-684eb9484cfb",
        "storage_key": "property/6737460151192631/019e8497-e551-7419-b8a4-684eb9484cfb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and comfort of this well-appointed bathroom, featuring a spacious bathtub, a modern vanity with a sink, and ample storage space.",
      "link": "",
      "alt_text": "A modern bathroom with a bathtub, toilet, and vanity with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_939f010e-63e6-42b9-adb6-546a56af2c3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-e27d-759f-8546-fed64c83d270.webp",
      "image_media": {
        "alt_text": "Bedroom with doors leading to other rooms and a view of the bathroom.",
        "public_id": "019e8497-e27d-759f-8546-fed64c83d270",
        "storage_key": "property/6737460151192631/019e8497-e27d-759f-8546-fed64c83d270.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting and access to en-suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with doors leading to other rooms and a view of the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_58a9d161-27b3-4182-b222-a4980f08a012",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-e53f-76db-8f13-a4d1c425f678.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with sink, faucet, mirror, and shower visible through an open door.",
        "public_id": "019e8497-e53f-76db-8f13-a4d1c425f678",
        "storage_key": "property/6737460151192631/019e8497-e53f-76db-8f13-a4d1c425f678.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a spacious vanity, modern fixtures, and a clean, contemporary design. The attached shower offers a private retreat.",
      "link": "",
      "alt_text": "Modern bathroom vanity with sink, faucet, mirror, and shower visible through an open door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba7d8e30-db6e-4f5c-b656-ac1b8cb922b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-9903-71e5-9245-5cfa5153fc56.webp",
      "image_media": {
        "alt_text": "Covered parking area with garages and grassy lawn.",
        "public_id": "019e8497-9903-71e5-9245-5cfa5153fc56",
        "storage_key": "property/6737460151192631/019e8497-9903-71e5-9245-5cfa5153fc56.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Covered parking spaces and individual garages are available for residents, providing convenient and secure vehicle storage.",
      "link": "",
      "alt_text": "Covered parking area with garages and grassy lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4fdd5d68-b963-474a-bd35-f636c7e208f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-df03-709d-af39-c6b97cfcbf55.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and a window with blinds. A doorway leads to the bathroom.",
        "public_id": "019e8497-df03-709d-af39-c6b97cfcbf55",
        "storage_key": "property/6737460151192631/019e8497-df03-709d-af39-c6b97cfcbf55.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and ample natural light from the window with blinds. The adjacent bathroom is easily accessible through the doorway.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan and a window with blinds. A doorway leads to the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9401a202-260e-448a-9857-47cfd4fcc7c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-dabb-744a-a38a-9fde08105530.webp",
      "image_media": {
        "alt_text": "White tiled bathtub and shower in apartment bathroom",
        "public_id": "019e8497-dabb-744a-a38a-9fde08105530",
        "storage_key": "property/6737460151192631/019e8497-dabb-744a-a38a-9fde08105530.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Clean and bright bathroom featuring a white tiled bathtub and shower area, with a closet visible to the left containing a laundry basket and shelving.",
      "link": "",
      "alt_text": "White tiled bathtub and shower in apartment bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8bdfaae7-8f0e-4d83-b75b-d1c30dc53cb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-9e16-751d-a441-d195c2b44f53.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with agility equipment, benches, and a covered picnic area.",
        "public_id": "019e8497-9e16-751d-a441-d195c2b44f53",
        "storage_key": "property/6737460151192631/019e8497-9e16-751d-a441-d195c2b44f53.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced-in dog park, complete with agility equipment for your furry friends and a covered picnic area for residents.",
      "link": "",
      "alt_text": "Fenced-in dog park with agility equipment, benches, and a covered picnic area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d15f0df1-1275-49ee-be54-83d213286a9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-701a-7396-bf86-3204b1d06ae6.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub area surrounded by apartment buildings and lush greenery.",
        "public_id": "019e8497-701a-7396-bf86-3204b1d06ae6",
        "storage_key": "property/6737460151192631/019e8497-701a-7396-bf86-3204b1d06ae6.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a relaxing dip in our sparkling swimming pool or unwind in the soothing hot tub, surrounded by beautiful landscaping and comfortable lounge areas.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and hot tub area surrounded by apartment buildings and lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f816243-b53b-486d-87cc-d9f0399304a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-2a23-728a-908a-1e9383ac12e1.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and trees.",
        "public_id": "019e8497-2a23-728a-908a-1e9383ac12e1",
        "storage_key": "property/6737460151192631/019e8497-2a23-728a-908a-1e9383ac12e1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained grounds with pathways winding through manicured lawns and mature trees, offering a serene and welcoming environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with lush green lawns and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ca9062cc-2f27-435c-ba71-5067fd2dba38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-67e8-70da-abe9-1e274004d27d.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool and spa with lounge chairs and umbrellas.",
        "public_id": "019e8497-67e8-70da-abe9-1e274004d27d",
        "storage_key": "property/6737460151192631/019e8497-67e8-70da-abe9-1e274004d27d.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool and spa, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool and spa with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c2afec3a-bce7-4cf8-9586-d26c490a118f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-675a-7062-bef4-393e39920133.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with buildings, parking, and amenities.",
        "public_id": "019e8497-675a-7062-bef4-393e39920133",
        "storage_key": "property/6737460151192631/019e8497-675a-7062-bef4-393e39920133.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "View of apartment buildings, covered parking, green spaces, and a pool area.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with buildings, parking, and amenities.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_20d80c9f-1410-4607-b612-1427ac08ca13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-5a2c-7290-ab91-a14a6b2e561f.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and surrounding lounge areas at a multifamily property.",
        "public_id": "019e8497-5a2c-7290-ab91-a14a6b2e561f",
        "storage_key": "property/6737460151192631/019e8497-5a2c-7290-ab91-a14a6b2e561f.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling resort-style pool, complete with ample lounge seating and lush landscaping, at our beautiful multifamily community.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and surrounding lounge areas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83831999-af12-4994-9932-0b9e3bfef846",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-5835-701e-b044-a2670af0fdf4.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property complex with a pool and surrounding buildings.",
        "public_id": "019e8497-5835-701e-b044-a2670af0fdf4",
        "storage_key": "property/6737460151192631/019e8497-5835-701e-b044-a2670af0fdf4.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Experience resort-style living with our stunning outdoor pool and beautifully landscaped grounds, surrounded by our spacious apartment buildings.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property complex with a pool and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e08bf580-8031-4f58-a750-b4e185328428",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8496-f8dd-7769-a424-c1ae6a0e409c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, with apartment buildings in the background.",
        "public_id": "019e8496-f8dd-7769-a424-c1ae6a0e409c",
        "storage_key": "property/6737460151192631/019e8496-f8dd-7769-a424-c1ae6a0e409c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and colorful umbrellas. Enjoy the resort-style amenities at our community.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_17432c7f-eb04-428e-be35-a1f3a427e8e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-17d3-7017-8c99-550a065fd698.webp",
      "image_media": {
        "alt_text": "Community room with a large table and chairs, featuring mirrored walls and large windows overlooking an outdoor area.",
        "public_id": "019e8497-17d3-7017-8c99-550a065fd698",
        "storage_key": "property/6737460151192631/019e8497-17d3-7017-8c99-550a065fd698.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather in the community room, a versatile space perfect for events or casual get-togethers, featuring a large dining table, comfortable seating, and abundant natural light.",
      "link": "",
      "alt_text": "Community room with a large table and chairs, featuring mirrored walls and large windows overlooking an outdoor area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8880baaf-f30b-4cd5-b53b-6a1a34ca1967",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8496-f632-7628-b28f-f4c23740539f.webp",
      "image_media": {
        "alt_text": "Garage doors on a multifamily property",
        "public_id": "019e8496-f632-7628-b28f-f4c23740539f",
        "storage_key": "property/6737460151192631/019e8496-f632-7628-b28f-f4c23740539f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a row of garage doors on a multifamily property.",
      "link": "",
      "alt_text": "Garage doors on a multifamily property",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_688718f6-d3ce-423c-9152-eed02aa2ac94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8497-38e5-77dc-b8fe-30956cc88f46.webp",
      "image_media": {
        "alt_text": "Exterior of the apartment complex's main building with a brick facade and large arched entryway.",
        "public_id": "019e8497-38e5-77dc-b8fe-30956cc88f46",
        "storage_key": "property/6737460151192631/019e8497-38e5-77dc-b8fe-30956cc88f46.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Welcome to our beautiful apartment community, featuring a striking brick building with a grand arched entrance and lush landscaping.",
      "link": "",
      "alt_text": "Exterior of the apartment complex's main building with a brick facade and large arched entryway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31a7fa86-9dc8-4e4f-902e-0523fb96c73b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8496-f1e6-754e-b38d-d9469e451408.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and a green table.",
        "public_id": "019e8496-f1e6-754e-b38d-d9469e451408",
        "storage_key": "property/6737460151192631/019e8496-f1e6-754e-b38d-d9469e451408.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our pet-friendly community with a dedicated dog park featuring agility equipment, perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment and a green table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b456f381-e7ed-40ec-b10f-bdbcd8b2b265",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8496-ef42-7108-b1b4-9a0369a4981c.webp",
      "image_media": {
        "alt_text": "Sand volleyball court with a net and blue posts.",
        "public_id": "019e8496-ef42-7108-b1b4-9a0369a4981c",
        "storage_key": "property/6737460151192631/019e8496-ef42-7108-b1b4-9a0369a4981c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly game on the sand volleyball court, perfect for outdoor fun and recreation.",
      "link": "",
      "alt_text": "Sand volleyball court with a net and blue posts.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8c85201-5c9b-4d02-bbb9-1598c6f0a96e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e8496-f276-770e-afdb-f71d1ee42baf.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with manicured lawns and a paved walkway.",
        "public_id": "019e8496-f276-770e-afdb-f71d1ee42baf",
        "storage_key": "property/6737460151192631/019e8496-f276-770e-afdb-f71d1ee42baf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment building featuring brick accents, outdoor staircases, and lush green landscaping. A paved walkway leads through the well-maintained grounds.",
      "link": "",
      "alt_text": "Apartment building exterior with manicured lawns and a paved walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_5d761ca9-675c-4d82-8871-f6e4b9d0b92d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Yummy Yummy",
      "poi_type": "Restaurants",
      "poi_address": "2310 FM 2004, Texas City, TX 77591, USA",
      "poi_short_description": "All-you-can-eat eatery featuring seafood, sushi, hibachi and Chinese fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-12ef-7228-83b5-12829070b956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-12ef-7228-83b5-12829070b956",
        "storage_key": "property/6737460151192631/019e1dec-12ef-7228-83b5-12829070b956.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2521164744829942301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yummy-yummy",
      "poi_latitude": "29.4069693",
      "poi_longitude": "-95.0305521",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 409-927-5066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_wmFbN_P4YRHbrTS_r5_CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_b1830d4d-2d1c-4256-90c3-9062dde48bf0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Jack in the Box",
      "poi_type": "Restaurants",
      "poi_address": "2101 FM 2004, Texas City, TX 77591, USA",
      "poi_short_description": "Burgers, chicken, tacos & breakfast items fill out the menu at this fast-food chain.",
      "poi_long_description": "Burgers, chicken, tacos & breakfast items fill out the menu at this fast-food chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-0b97-725d-b975-71fd30210d51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-0b97-725d-b975-71fd30210d51",
        "storage_key": "property/6737460151192631/019e1dec-0b97-725d-b975-71fd30210d51.webp",
        "width": 1280,
        "height": 973
      },
      "poi_business_url": "https://locations.jackinthebox.com/us/tx/texas-city/2101-fm-2004-rd?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=331121536641349566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-in-the-box",
      "poi_latitude": "29.4068037",
      "poi_longitude": "-95.0316645",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 409-986-7297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy09WrnF-P4YRvjf9gEhhmAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_8f530831-046f-4a71-bf1f-4dffd0871e90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Shipley Do-Nuts",
      "poi_type": "Restaurants",
      "poi_address": "2319 Palmer Hwy, Texas City, TX 77590, USA",
      "poi_short_description": "Chain with a variety of yeast, cake & filled donuts, plus kolaches, espresso drinks & smoothies.",
      "poi_long_description": "Chain with a variety of yeast, cake & filled donuts, plus kolaches, espresso drinks & smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-0fdb-700d-a9f6-c4a2a29d5de2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-0fdb-700d-a9f6-c4a2a29d5de2",
        "storage_key": "property/6737460151192631/019e1dec-0fdb-700d-a9f6-c4a2a29d5de2.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://shipleydonuts.com/locations/2319-palmer-hwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=17892193943052908198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shipley-do-nuts",
      "poi_latitude": "29.3935816",
      "poi_longitude": "-94.9282495",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-945-7551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSRBANaJ5P4YRpnYQJJjXTfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_6c35a187-be92-4130-9356-ab5a78f44b7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Luna's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "Mainland Crossing, 9300 Emmett F Lowry Expy STE 168, Texas City, TX 77591, USA",
      "poi_short_description": "Casual Tex-Mex eatery featuring tacos, fajitas, enchiladas, margaritas and other traditional dishes, plus a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-17fd-740d-b0e3-ecbdca0026e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-17fd-740d-b0e3-ecbdca0026e4",
        "storage_key": "property/6737460151192631/019e1dec-17fd-740d-b0e3-ecbdca0026e4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lunasmexicanrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1540922617518303835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lunas-mexican-restaurant",
      "poi_latitude": "29.4036884",
      "poi_longitude": "-95.0155258",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 409-986-7919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-hdmpN-P4YRWyqL2_R0YhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_47ac8b76-aa6b-49a4-b90f-07fedc2b0a53",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10212 Emmett F Lowry Expy, Texas City, TX 77591, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-118c-71de-a4e7-e7e28becdf70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-118c-71de-a4e7-e7e28becdf70",
        "storage_key": "property/6737460151192631/019e1dec-118c-71de-a4e7-e7e28becdf70.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olivegarden.com/locations/tx/texas-city/texas-city-mall-of-the-mainland/1398?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:texas-city-tx-1398_pl:locurl_rd:1297",
      "poi_directions_map_url": "https://maps.google.com/?cid=11062377695196096352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "29.403504",
      "poi_longitude": "-95.024171",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-986-7471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNwOpvGR-P4YRYCdeHed1hZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1d0c0716-3d9c-4028-bdeb-3d86fbf5433e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Stuttgarden Tavern",
      "poi_type": "Restaurants",
      "poi_address": "10000 Emmett F Lowry Expy Suite 1346, Texas City, TX 77591, USA",
      "poi_short_description": "Roomy, upbeat beer garden with outdoor tables serving hearty Bavarian fare, draft beers & cocktails.",
      "poi_long_description": "Roomy, upbeat beer garden with outdoor tables serving hearty Bavarian fare, draft beers & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-0b73-71ea-b660-d566289abb39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-0b73-71ea-b660-d566289abb39",
        "storage_key": "property/6737460151192631/019e1dec-0b73-71ea-b660-d566289abb39.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://stuttgardentavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9527850826170220086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stuttgarden-tavern",
      "poi_latitude": "29.4065982",
      "poi_longitude": "-95.0262341",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-316-9409",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-5670-726a-8d82-fc1a7d441a89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-5670-726a-8d82-fc1a7d441a89",
        "storage_key": "property/6737460151192631/019e1dec-5670-726a-8d82-fc1a7d441a89.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBx-UAnt-P4YRNr7Jfti5OYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_4fe32554-f004-4c9c-810f-1fddefb978f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Mainland City Centre",
      "poi_type": "Restaurants",
      "poi_address": "10000 Emmett F Lowry Expy, Texas City, TX 77591, USA",
      "poi_short_description": "Shopping center also featuring a gym, restaurants and a zip line.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-146e-71de-a6b8-0b9ebce3e7db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-146e-71de-a6b8-0b9ebce3e7db",
        "storage_key": "property/6737460151192631/019e1dec-146e-71de-a6b8-0b9ebce3e7db.webp",
        "width": 1280,
        "height": 412
      },
      "poi_business_url": "https://mainlandcitycentre.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3620502623367643920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mainland-city-centre",
      "poi_latitude": "29.4060971",
      "poi_longitude": "-95.0256245",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-927-5421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75a6-72a6-9e1f-dcb190e9d5c1",
        "storage_key": "property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKSh-GHt-P4YREMMyJvSbPjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7fd3d745-f030-4566-b014-2c6a58c96c14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Charleys Cheesesteaks",
      "poi_type": "Restaurants",
      "poi_address": "5885 Gulf Fwy Space 349, Texas City, TX 77591, USA",
      "poi_short_description": "Counter-service chain offering a range of Philly-style cheesesteaks, loaded fries & lemonades.",
      "poi_long_description": "Counter-service chain offering a range of Philly-style cheesesteaks, loaded fries & lemonades.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-1353-766f-935a-016362eafee0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-1353-766f-935a-016362eafee0",
        "storage_key": "property/6737460151192631/019e1dec-1353-766f-935a-016362eafee0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.charleys.com/menu/galveston-tanger-outlet-mall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8612050277962892309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charleys-cheesesteaks",
      "poi_latitude": "29.4246951",
      "poi_longitude": "-95.0594114",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-337-6180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu9Zvcfh9P4YRFUTIZRkmhHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_aa86ea93-62ca-443b-9aab-c69d89fc30a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "6131 Gulf Fwy, Texas City, TX 77591, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-2678-76af-81d9-2a5dca5ea764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dea-2678-76af-81d9-2a5dca5ea764",
        "storage_key": "property/6737460151192631/019e1dea-2678-76af-81d9-2a5dca5ea764.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas-city?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=15982760730839638390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "29.4288195",
      "poi_longitude": "-95.0599878",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-655-2159",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWTUqiCDQIYRdmHCUzQszt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_8ff2aa76-4cb0-48ca-93c6-be0e4353197b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Denny's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1201 TX-146, Texas City, TX 77590, USA",
      "poi_short_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_long_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-1879-74d9-95fe-070de7cd3d93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-1879-74d9-95fe-070de7cd3d93",
        "storage_key": "property/6737460151192631/019e1dec-1879-74d9-95fe-070de7cd3d93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dennys.com/TX/TEXAS-CITY/247626?utm_source=G&utm_medium=organic&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=17895638690341457752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dennys-restaurant",
      "poi_latitude": "29.3943791",
      "poi_longitude": "-94.9520022",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-948-0756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM4X7vxR5P4YRWA-K3pIUWvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c8e611e6-e384-463c-8875-a98d662ded71",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "United States Postal Service",
      "poi_type": "Restaurants",
      "poi_address": "2002 11th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-13ad-72d4-99e7-9cf39fa65f3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-13ad-72d4-99e7-9cf39fa65f3e",
        "storage_key": "property/6737460151192631/019e1dec-13ad-72d4-99e7-9cf39fa65f3e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tools.usps.com/locations/details/1384482?utm_source=google-my-business-url&utm_medium=search&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8094260279257424646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-postal-service",
      "poi_latitude": "29.3955943",
      "poi_longitude": "-94.92456260000002",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-275-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-7b86-70e8-aef7-5b770f4c5405.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-7b86-70e8-aef7-5b770f4c5405",
        "storage_key": "property/6737460151192631/019e1dea-7b86-70e8-aef7-5b770f4c5405.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRv-Sr15P4YRBmOxuNaWVHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "post_office"
    },
    {
      "id": "custom_7b831ab9-779c-477d-87dc-b3cf9967d1f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "The Fish Spot",
      "poi_type": "Restaurants",
      "poi_address": "4009 20th St N, Texas City, TX 77590, USA",
      "poi_short_description": "Small setup on the marina selling fishing bait & offering a full restaurant for casual eats & beer.",
      "poi_long_description": "Small setup on the marina selling fishing bait & offering a full restaurant for casual eats & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-1866-74bb-ac0f-29c0eff48d0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-1866-74bb-ac0f-29c0eff48d0e",
        "storage_key": "property/6737460151192631/019e1dec-1866-74bb-ac0f-29c0eff48d0e.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2053208989736803646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-fish-spot",
      "poi_latitude": "29.4191703",
      "poi_longitude": "-94.9256439",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 409-359-3630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYKV5Yd5P4YRPp3morJ2fhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_adb85d00-1957-48f6-a67a-4712f23f618a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Hoppe’s Sports Grill",
      "poi_type": "Restaurants",
      "poi_address": "10000 Emmett F Lowry Expy, Texas City, TX 77591, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-18bf-71cc-aa52-fedf6936689f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-18bf-71cc-aa52-fedf6936689f",
        "storage_key": "property/6737460151192631/019e1dec-18bf-71cc-aa52-fedf6936689f.webp",
        "width": 1024,
        "height": 1024
      },
      "poi_business_url": "https://www.hoppesbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2520857058380684277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hoppes-sports-grill",
      "poi_latitude": "29.4061284",
      "poi_longitude": "-95.0256966",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-316-4132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs7VLPgB_P4YR9RtRdiPi-yI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8b9cb038-cb34-4265-a124-c02f1253bf8e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Brick & Spoon",
      "poi_type": "Restaurants",
      "poi_address": "10000 Emmett F Lowry Expy Suite 1134, Texas City, TX 77591, USA",
      "poi_short_description": "Upscale eatery serving breakfast staples such as pancakes and omelets as well as lunch fare such as burgers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-1d0e-708e-bed9-8c149b15c454.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-1d0e-708e-bed9-8c149b15c454",
        "storage_key": "property/6737460151192631/019e1dec-1d0e-708e-bed9-8c149b15c454.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brickandspoon.com/texas-city-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=505998169053109664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brick--spoon",
      "poi_latitude": "29.4061086",
      "poi_longitude": "-95.0253959",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-440-8535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4TRqPtR_P4YRoJ1oY6eqBQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_629e0e36-7672-4b6b-bf39-8f661441af1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Always Market #4",
      "poi_type": "Shopping & Retail",
      "poi_address": "Texas City, TX 77591, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-1d0c-7028-ae44-17c0fcd363b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-1d0c-7028-ae44-17c0fcd363b4",
        "storage_key": "property/6737460151192631/019e1dec-1d0c-7028-ae44-17c0fcd363b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18394490667559956144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "always-market-4",
      "poi_latitude": "29.407515",
      "poi_longitude": "-95.0316374",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-56a2-74f4-ae1b-24e21220b84a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-56a2-74f4-ae1b-24e21220b84a",
        "storage_key": "property/6737460151192631/019e1dec-56a2-74f4-ae1b-24e21220b84a.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJiVXK2ed_P4YRsC4m0M1bRv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_bc23f534-6fd0-4832-9841-690fe32f5100",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Mainland Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "5202 FM1765, Texas City, TX 77591, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3887584221610793393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mainland-food-mart",
      "poi_latitude": "29.3793303",
      "poi_longitude": "-94.9710715",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-5670-726a-8d83-03cd8651c978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-5670-726a-8d83-03cd8651c978",
        "storage_key": "property/6737460151192631/019e1dec-5670-726a-8d83-03cd8651c978.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6rGmC55P4YRsVmGk0B58zU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_e5cc333f-f557-4524-bf82-8b5582511aee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Food Rite Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5320 FM1765, Texas City, TX 77591, USA",
      "poi_short_description": "Family-owned grocery store with a deli counter offering Cajun-Creole & Mexican dishes.",
      "poi_long_description": "Family-owned grocery store with a deli counter offering Cajun-Creole & Mexican dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-1c17-749c-97a5-15b6c0b9eca1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-1c17-749c-97a5-15b6c0b9eca1",
        "storage_key": "property/6737460151192631/019e1dec-1c17-749c-97a5-15b6c0b9eca1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8968080517224312720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-rite-market",
      "poi_latitude": "29.3796552",
      "poi_longitude": "-94.9722231",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-938-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76cf-7360-86b5-9772d4dce88f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76cf-7360-86b5-9772d4dce88f",
        "storage_key": "property/6737460151192631/019e1dea-76cf-7360-86b5-9772d4dce88f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK1gbLlF-P4YRkK9BKrcFdXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_dc140ee8-2935-4373-9d22-332f9f6ce41c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2902 Palmer Hwy, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-1c7e-72d8-87d7-b3e2e17e1293.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-1c7e-72d8-87d7-b3e2e17e1293",
        "storage_key": "property/6737460151192631/019e1dec-1c7e-72d8-87d7-b3e2e17e1293.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/texas-city-tx-pharmacies/2902-palmer-hwy-texas-city-tx-77590/storeid=6319?WT.mc_id=LS_GOOGLE_RX_6319",
      "poi_directions_map_url": "https://maps.google.com/?cid=1948788641362287576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.3959722",
      "poi_longitude": "-94.9376469",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-945-3426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-5671-7118-a3b7-d1325d4d9c54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-5671-7118-a3b7-d1325d4d9c54",
        "storage_key": "property/6737460151192631/019e1dec-5671-7118-a3b7-d1325d4d9c54.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU2sA1gp5P4YR2Bu3tvF8Cxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9c7a68a2-e008-4607-a601-d0395f3da3a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "3502 Palmer Hwy, Texas City, TX 77590, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-2529-73f9-8ae8-cef385d87e9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dea-2529-73f9-8ae8-cef385d87e9b",
        "storage_key": "property/6737460151192631/019e1dea-2529-73f9-8ae8-cef385d87e9b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/texas-city/texas-city-h-e-b-662?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=2617118570670757559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.3971927",
      "poi_longitude": "-94.9495983",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-948-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76cf-7360-86b5-9772d4dce88f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76cf-7360-86b5-9772d4dce88f",
        "storage_key": "property/6737460151192631/019e1dea-76cf-7360-86b5-9772d4dce88f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr9Ocl2x5P4YRt5boU3nfUSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_22331c1a-1916-4dfd-ae81-b323e841a318",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "3442 Palmer Hwy suite B, Texas City, TX 77590, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-1f5f-774c-b14b-4277f7eb06fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-1f5f-774c-b14b-4277f7eb06fb",
        "storage_key": "property/6737460151192631/019e1dec-1f5f-774c-b14b-4277f7eb06fb.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/tx/texas-city/3442-palmer-hwy-suite-b?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12468251535168646001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "29.3968674",
      "poi_longitude": "-94.9479439",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-908-1023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75a6-72a6-9e1f-dcb190e9d5c1",
        "storage_key": "property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgWMg1Gx5P4YRcSvyK7YgCK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_7f9b00ac-4c57-4a0b-a16e-9e089475de6d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "8002 FM1765, Texas City, TX 77591, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-1f8c-77ad-8930-66000e7b68a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-1f8c-77ad-8930-66000e7b68a6",
        "storage_key": "property/6737460151192631/019e1dec-1f8c-77ad-8930-66000e7b68a6.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/tx/texas-city/12332",
      "poi_directions_map_url": "https://maps.google.com/?cid=38643497835784171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "29.3790995",
      "poi_longitude": "-94.999505",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-359-5260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75a6-72a6-9e1f-dcb190e9d5c1",
        "storage_key": "property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlzfB5eZ-P4YR62dheQ5KiQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_5a2df539-685e-4e9a-8945-2dde6a7b0bec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6410 I-45, La Marque, TX 77568, USA",
      "poi_short_description": "Department store offering an array of merchandise from electronics and furniture to groceries, clothing, and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2108-728d-9a7d-5a1dd170e313.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2108-728d-9a7d-5a1dd170e313",
        "storage_key": "property/6737460151192631/019e1dec-2108-728d-9a7d-5a1dd170e313.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/529-la-marque-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3784722405290938000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.4023017",
      "poi_longitude": "-95.0374603",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-986-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75a6-72a6-9e1f-dcb190e9d5c1",
        "storage_key": "property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTdIwdW5-P4YRkA7UrPkIhjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_bfe31ae0-b92b-4e98-96aa-06bddbf2a21d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "6614 Gulf Fwy, La Marque, TX 77568, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-20bd-74bf-bddf-594968929b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-20bd-74bf-bddf-594968929b3e",
        "storage_key": "property/6737460151192631/019e1dec-20bd-74bf-bddf-594968929b3e.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.samsclub.com/club/8190-la-marque-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=5797083039240785889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "29.4038124",
      "poi_longitude": "-95.0391387",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-986-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75a6-72a6-9e1f-dcb190e9d5c1",
        "storage_key": "property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFX4WMYh-P4YR4Y9jV09gc1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_224412e9-9b36-4ad9-9071-73faf92e8a3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "College of the Mainland",
      "poi_type": "Education",
      "poi_address": "1200 N Amburn Rd, Texas City, TX 77591, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-297b-735b-938e-e64a66289bd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dea-297b-735b-938e-e64a66289bd4",
        "storage_key": "property/6737460151192631/019e1dea-297b-735b-938e-e64a66289bd4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.com.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13149779945003228785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-of-the-mainland",
      "poi_latitude": "29.3954351",
      "poi_longitude": "-95.0010811",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 409-938-1211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC1yXW5V-P4YRcR55gDBnfbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f158c8f8-a6fa-4024-8d1c-d9bb43614aa2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Calvin Vincent Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "1805 13th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2300-77ef-a9d2-b16fca09e475.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2300-77ef-a9d2-b16fca09e475",
        "storage_key": "property/6737460151192631/019e1dec-2300-77ef-a9d2-b16fca09e475.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://calvinvincent.tcisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962300692252853159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "calvin-vincent-early-childhood-center",
      "poi_latitude": "29.3970328",
      "poi_longitude": "-94.9223337",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-916-0512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuUXiKpZ5P4YRpwP4y_58YHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ed37999f-9d48-4b3b-a8a8-40a9583eb882",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Levi Fry Intermediate School",
      "poi_type": "Education",
      "poi_address": "300 25th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-221d-70bf-b985-49bff45b0994.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-221d-70bf-b985-49bff45b0994",
        "storage_key": "property/6737460151192631/019e1dec-221d-70bf-b985-49bff45b0994.webp",
        "width": 1280,
        "height": 748
      },
      "poi_business_url": "http://www.tcisd.org/index.aspx?nid=155",
      "poi_directions_map_url": "https://maps.google.com/?cid=14551242402760976725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "levi-fry-intermediate-school",
      "poi_latitude": "29.4099009",
      "poi_longitude": "-94.8972116",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 409-916-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt5Yxm7h5P4YRVWkrmd5l8Mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_07a2b728-1e5b-48c3-b018-f81b8ef4ce70",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Heights",
      "poi_type": "Education",
      "poi_address": "300 N Logan St, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://heights.tcisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2348844436934291572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heights",
      "poi_latitude": "29.3875556",
      "poi_longitude": "-94.9290298",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-916-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJveyDZKZ5P4YRdPAeGJLFmCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_256f36a2-4170-40e5-98d4-84885a34c5cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Kohfeldt Elementary School",
      "poi_type": "Education",
      "poi_address": "1705 13th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://kohfeldt.tcisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6548396846102836206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohfeldt-elementary-school",
      "poi_latitude": "29.3962318",
      "poi_longitude": "-94.9211917",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 409-916-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrZgmtbh5P4YR7nM_lDyU4Fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e45d591d-04a5-4ba6-a570-daaec6de10c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Manuel Guajardo, Jr. Elementary School",
      "poi_type": "Education",
      "poi_address": "2300 21st St N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://guajardo.tcisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14662059542170072931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manuel-guajardo-jr-elementary-school",
      "poi_latitude": "29.4058474",
      "poi_longitude": "-94.9241969",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-916-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8_x_YZB5P4YRY3esfngZess",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7676e633-5c0a-4e3d-8e73-67dc0eeddf5e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Roosevelt Wilson Elementary",
      "poi_type": "Education",
      "poi_address": "301 16th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://roosevelt.tcisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5197186843383633724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roosevelt-wilson-elementary",
      "poi_latitude": "29.3995733",
      "poi_longitude": "-94.8986143",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 409-916-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo_Ay0uB5P4YRPBc37-UdIEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_47ce29c6-05d1-4cde-aa34-785e245d9fba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Simms Elementary School",
      "poi_type": "Education",
      "poi_address": "529 N Westward St, Texas City, TX 77591, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://simms.tcisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14553678266852953112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simms-elementary-school",
      "poi_latitude": "29.3893795",
      "poi_longitude": "-94.9892425",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-908-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUafkHvN_P4YRGMwXZ0YN-ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c8df2d72-ade1-41ca-b38e-27235a5ae3b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Blocker Middle School",
      "poi_type": "Education",
      "poi_address": "1800 9th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2359-7157-90cf-1215706f3ce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2359-7157-90cf-1215706f3ce0",
        "storage_key": "property/6737460151192631/019e1dec-2359-7157-90cf-1215706f3ce0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tcisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13236559660425515419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blocker-middle-school",
      "poi_latitude": "29.3939411",
      "poi_longitude": "-94.9215812",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-916-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb-uGP-d5P4YRm5Htf-G0sbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_cc471524-d832-4e43-9929-2e83a821be5b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "La Marque High School",
      "poi_type": "Education",
      "poi_address": "397 Duroux Rd, La Marque, TX 77568, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-23d8-71ef-b6ea-7130917bc12a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-23d8-71ef-b6ea-7130917bc12a",
        "storage_key": "property/6737460151192631/019e1dec-23d8-71ef-b6ea-7130917bc12a.webp",
        "width": 722,
        "height": 1280
      },
      "poi_business_url": "https://www.tcisd.org/departments/athletics/la-marque-high-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=13015502930588200482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-marque-high-school",
      "poi_latitude": "29.37597929999999",
      "poi_longitude": "-94.9945729",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-938-4261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8yO7l95-P4YRIu7DzvRaoLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_56bbb7a3-4dd6-4705-8e91-044a303f15cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Texas City PREMIERE LUX 12 + Pizza Pub",
      "poi_type": "Entertainment",
      "poi_address": "10000 Emmett F Lowry Expy, Texas City, TX 77591, USA",
      "poi_short_description": "Multiscreen theater chain with stadium seating; some locations with IMAX screen & D-BOX flicks.",
      "poi_long_description": "Multiscreen theater chain with stadium seating; some locations with IMAX screen & D-BOX flicks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2820-7698-b819-928306ebeb8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2820-7698-b819-928306ebeb8d",
        "storage_key": "property/6737460151192631/019e1dec-2820-7698-b819-928306ebeb8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pccmovies.com/texascity",
      "poi_directions_map_url": "https://maps.google.com/?cid=8129646985674817949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-city-premiere-lux-12--pizza-pub",
      "poi_latitude": "29.40693349999999",
      "poi_longitude": "-95.0253358",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-316-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-5690-7123-ae85-3ddee5dbe281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-5690-7123-ae85-3ddee5dbe281",
        "storage_key": "property/6737460151192631/019e1dec-5690-7123-ae85-3ddee5dbe281.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYIQCH5_P4YRnQF5WtxO0nA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_df2c821f-0367-4d9a-b001-ca16bc3b2ec3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Texas City Museum",
      "poi_type": "Entertainment",
      "poi_address": "409 6th St N, Texas City, TX 77590, USA",
      "poi_short_description": "Railroad-themed, two-level museum showcasing the history of Texas City.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-28d1-76fc-94b6-969633da231d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-28d1-76fc-94b6-969633da231d",
        "storage_key": "property/6737460151192631/019e1dec-28d1-76fc-94b6-969633da231d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texascitytx.gov/476/Museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=9656856485525299627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-city-museum",
      "poi_latitude": "29.3885569",
      "poi_longitude": "-94.9028959",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-229-1660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75b6-75ba-a13a-c2038d9448b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75b6-75ba-a13a-c2038d9448b1",
        "storage_key": "property/6737460151192631/019e1dea-75b6-75ba-a13a-c2038d9448b1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42mA3tp5P4YRq6GpMs8LBIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_037cd849-4220-4778-a7c6-562c3763af42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Texas City Dike",
      "poi_type": "Entertainment",
      "poi_address": "Dike Rd, Texas City, TX 77590, USA",
      "poi_short_description": "Fishing spot with a boat ramp and camping facilities, plus opportunities to find shells and sea glass.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2925-73c6-9a6e-4af73392144a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2925-73c6-9a6e-4af73392144a",
        "storage_key": "property/6737460151192631/019e1dec-2925-73c6-9a6e-4af73392144a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texascitytx.gov/504/Texas-City-Dike",
      "poi_directions_map_url": "https://maps.google.com/?cid=7995517264149982097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-city-dike",
      "poi_latitude": "29.3898492",
      "poi_longitude": "-94.8854653",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp6rZq2V3P4YRkasp9ZbI9W4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fishing_pier"
    },
    {
      "id": "custom_0b2c6bde-c5d2-4cab-a66d-0f295b87ebc3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Bayou Wildlife Zoo",
      "poi_type": "Entertainment",
      "poi_address": "5050 FM517, Alvin, TX 77511, USA",
      "poi_short_description": "Visitors ride trams to see more than 500 animals and 60 species, plus a petting zoo & pony rides.",
      "poi_long_description": "Visitors ride trams to see more than 500 animals and 60 species, plus a petting zoo & pony rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2885-715b-a25c-4e8dd4b85997.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2885-715b-a25c-4e8dd4b85997",
        "storage_key": "property/6737460151192631/019e1dec-2885-715b-a25c-4e8dd4b85997.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.bayouwildlifezoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5964785579672135000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayou-wildlife-zoo",
      "poi_latitude": "29.4309272",
      "poi_longitude": "-95.1693954",
      "poi_miles_from_property": "13.3",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 409-904-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxbnRgp9P4YRWOW6xeEsx1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_3018c2e9-d985-498a-ac71-d11e70e0c4fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Kemah Boardwalk",
      "poi_type": "Entertainment",
      "poi_address": "215 Kipp Ave, Kemah, TX 77565, USA",
      "poi_short_description": "Family-friendly entertainment including retro rides, a wooden roller coaster & two-story carousel.",
      "poi_long_description": "Family-friendly entertainment including retro rides, a wooden roller coaster & two-story carousel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2c4e-772a-8582-0688566376a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2c4e-772a-8582-0688566376a3",
        "storage_key": "property/6737460151192631/019e1dec-2c4e-772a-8582-0688566376a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kemahboardwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3506269467466928315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemah-boardwalk",
      "poi_latitude": "29.5473219",
      "poi_longitude": "-95.0202048",
      "poi_miles_from_property": "18.4",
      "poi_walking_minutes": "6 hours 46 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 281-535-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2iakAJjP4YRuxAq74DFqDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_3ef864e3-d50e-488d-9d5f-421754d2520f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Star Cinema Grill",
      "poi_type": "Entertainment",
      "poi_address": "702 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Cinema featuring dining options, heated reclining seats and waitstaff service, plus a bar for drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-3053-766f-ba3e-7f334e874639.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-3053-766f-ba3e-7f334e874639",
        "storage_key": "property/6737460151192631/019e1dec-3053-766f-ba3e-7f334e874639.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/baybrook",
      "poi_directions_map_url": "https://maps.google.com/?cid=12765688306792673863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill",
      "poi_latitude": "29.545818",
      "poi_longitude": "-95.1504157",
      "poi_miles_from_property": "16.5",
      "poi_walking_minutes": "6 hours 4 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-557-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-5690-7123-ae85-3ddee5dbe281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-5690-7123-ae85-3ddee5dbe281",
        "storage_key": "property/6737460151192631/019e1dec-5690-7123-ae85-3ddee5dbe281.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fTv5JacQIYRRzK8J-HVKLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_cfefc08e-59ac-419b-9519-41925f27bc57",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Bay Area Raceway",
      "poi_type": "Entertainment",
      "poi_address": "3825 Gulf Fwy, Dickinson, TX 77539, USA",
      "poi_short_description": "Quarter-mile go-kart racetrack with an arcade featuring video games, pinball, foosball & billiards.",
      "poi_long_description": "Quarter-mile go-kart racetrack with an arcade featuring video games, pinball, foosball & billiards.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2de7-761f-bcc3-dcbf2a76eb0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2de7-761f-bcc3-dcbf2a76eb0f",
        "storage_key": "property/6737460151192631/019e1dec-2de7-761f-bcc3-dcbf2a76eb0f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.bayarearaceway.com/?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5350639095919533297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-raceway",
      "poi_latitude": "29.4469204",
      "poi_longitude": "-95.0742939",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-337-7223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUJrI2-CQIYR8dyZqehJQUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "go_karting_venue"
    },
    {
      "id": "custom_ad0f277e-ec1d-4f6e-be25-401bfa83e2ec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "The Ballpark at League City",
      "poi_type": "Entertainment",
      "poi_address": "1150 Ballpark Wy, League City, TX 77573, USA",
      "poi_short_description": "Massive recreational athletic facility with baseball fields made to look like famous ballparks.",
      "poi_long_description": "Massive recreational athletic facility with baseball fields made to look like famous ballparks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2eb4-71bc-84e1-4bb0fde9986c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2eb4-71bc-84e1-4bb0fde9986c",
        "storage_key": "property/6737460151192631/019e1dec-2eb4-71bc-84e1-4bb0fde9986c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://leaguecitytx.gov/ballpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=9316778970622744418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ballpark-at-league-city",
      "poi_latitude": "29.4737899",
      "poi_longitude": "-95.1020718",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-316-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9WJ_9hyDQIYRYlfMghzZS4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_bc7a807f-a24e-47e6-afa2-5baa67338ab1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare Mainland",
      "poi_type": "Health and Wellness",
      "poi_address": "6801 Emmett F Lowry Expy, Texas City, TX 77591, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-39dd-71bb-8e98-54bb8a0c3e20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dea-39dd-71bb-8e98-54bb8a0c3e20",
        "storage_key": "property/6737460151192631/019e1dea-39dd-71bb-8e98-54bb8a0c3e20.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/mainland?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17671744895620705227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-mainland",
      "poi_latitude": "29.3946557",
      "poi_longitude": "-94.9865762",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 409-938-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76c1-746b-bc61-c6c0c58cbd74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76c1-746b-bc61-c6c0c58cbd74",
        "storage_key": "property/6737460151192631/019e1dea-76c1-746b-bc61-c6c0c58cbd74.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7adOBch-P4YRy2vLiFqmPvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_af3e5021-d6aa-446d-9382-6f3553503126",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "UTMB Health Urgent Care, Texas City",
      "poi_type": "Health and Wellness",
      "poi_address": "10121 Emmett F Lowry Expy, Texas City, TX 77591, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-31df-70c8-9b2a-9ecea838ceaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-31df-70c8-9b2a-9ecea838ceaa",
        "storage_key": "property/6737460151192631/019e1dec-31df-70c8-9b2a-9ecea838ceaa.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.utmbhealth.com/services/uc-er/urgent-care",
      "poi_directions_map_url": "https://maps.google.com/?cid=2996450524742373571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utmb-health-urgent-care-texas-city",
      "poi_latitude": "29.4010955",
      "poi_longitude": "-95.0229318",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-986-9686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7QpYmR-P4YRw1BNWuCHlSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_54a7ebb5-df6c-4883-a0e8-be80cacf3b9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Affinity Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2600 FM1764 #190, La Marque, TX 77568, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-32bf-7528-a601-423e87794242.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-32bf-7528-a601-423e87794242",
        "storage_key": "property/6737460151192631/019e1dec-32bf-7528-a601-423e87794242.webp",
        "width": 1280,
        "height": 693
      },
      "poi_business_url": "http://affinitydrs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7884537526183626050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "affinity-urgent-care",
      "poi_latitude": "29.4020298",
      "poi_longitude": "-95.0351017",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-886-8964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-ZiILaIQIYRQoVpIhuBa20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_9f6d016e-54ce-48a0-b568-077e936b9eb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3103 Palmer Hwy, Texas City, TX 77590, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-3456-70cb-afd5-a1553ef3cb81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-3456-70cb-afd5-a1553ef3cb81",
        "storage_key": "property/6737460151192631/019e1dec-3456-70cb-afd5-a1553ef3cb81.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3103+palmer+hwy-texas+city-tx-77590/id=10583",
      "poi_directions_map_url": "https://maps.google.com/?cid=8130284203506393748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "29.3945607",
      "poi_longitude": "-94.9412871",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-945-0702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-5671-7118-a3b7-d1325d4d9c54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-5671-7118-a3b7-d1325d4d9c54",
        "storage_key": "property/6737460151192631/019e1dec-5671-7118-a3b7-d1325d4d9c54.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwX9Nlgx5P4YRlOL3MGiS1HA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_47c83ebf-f708-4548-84dc-91a7bfffd265",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Genoa Healthcare",
      "poi_type": "Health and Wellness",
      "poi_address": "7510 FM1765 p1, Texas City, TX 77591, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-3492-70e2-bfce-387f3397699b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-3492-70e2-bfce-387f3397699b",
        "storage_key": "property/6737460151192631/019e1dec-3492-70e2-bfce-387f3397699b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.genoahealthcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13151822495420802641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genoa-healthcare",
      "poi_latitude": "29.3796731",
      "poi_longitude": "-94.9952528",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-359-5547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-5671-7118-a3b7-d1325d4d9c54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-5671-7118-a3b7-d1325d4d9c54",
        "storage_key": "property/6737460151192631/019e1dec-5671-7118-a3b7-d1325d4d9c54.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwAEDh1_P4YRUWaM1OCohLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f08f4ceb-3f74-4589-9ca4-6d7d21105182",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Texas City Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2506 25th Ave N suite 4, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12003946502147389318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-city-pharmacy",
      "poi_latitude": "29.4085442",
      "poi_longitude": "-94.9328615",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 409-655-3033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-5671-7118-a3b7-d1325d4d9c54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-5671-7118-a3b7-d1325d4d9c54",
        "storage_key": "property/6737460151192631/019e1dec-5671-7118-a3b7-d1325d4d9c54.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTRqFVp55P4YRhrdJe76VlqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_dbc6ce45-4e2b-4881-b22a-f68fe7b83375",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Lowry Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1900 5th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "Gym featuring 3 pools and a weight room, as well as friendly staff and exercise classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-34ff-7459-98f0-6202cf5497b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-34ff-7459-98f0-6202cf5497b7",
        "storage_key": "property/6737460151192631/019e1dec-34ff-7459-98f0-6202cf5497b7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.texascitytx.gov/835/Lowry-Fitness-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12934853568618624958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowry-fitness-center",
      "poi_latitude": "29.389645",
      "poi_longitude": "-94.9221611",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-643-5984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSY9_2bt5P4YRvvc088nUgbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6d7e16c5-ec4b-493c-8d6a-a0b1bd320434",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "World Gym Texas City",
      "poi_type": "Health and Wellness",
      "poi_address": "Mainland City Centre, 10000 Emmett F Lowry Expy Suite 5000 A, Texas City, TX 77591, USA",
      "poi_short_description": "Clean all-in-one gym offering cardio machines, free weights, boxing bags and basketball courts with 24/7 access.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-33fa-75bd-98c6-4f1b6c8ec716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dea-33fa-75bd-98c6-4f1b6c8ec716",
        "storage_key": "property/6737460151192631/019e1dea-33fa-75bd-98c6-4f1b6c8ec716.webp",
        "width": 945,
        "height": 945
      },
      "poi_business_url": "http://www.worldgym.com/texas-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13569122570724331218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "world-gym-texas-city",
      "poi_latitude": "29.4066437",
      "poi_longitude": "-95.028263",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 409-986-9675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5Pi33p-P4YR0k7C9RU1T7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_28b648e5-4495-44a2-9b6e-f92862bbbd40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Bay Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "800 Bay St N, Texas City, TX 77590, USA",
      "poi_short_description": "Butterfly gardens, hiking trails, a soccer field and playgrounds at this family-friendly outdoor area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-3624-750e-8fd5-b96eae391c90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-3624-750e-8fd5-b96eae391c90",
        "storage_key": "property/6737460151192631/019e1dec-3624-750e-8fd5-b96eae391c90.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://texascitytx.gov/Facilities/Facility/Details/Bay-Street-Park-6",
      "poi_directions_map_url": "https://maps.google.com/?cid=11879752824354470899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-street-park",
      "poi_latitude": "29.3970209",
      "poi_longitude": "-94.892356",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 409-948-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-7627-712f-8fc1-68dd5b12cfa8",
        "storage_key": "property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6ZpE2B3P4YR83sXi0Bc3aQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5a9989b4-e370-4b51-8c53-313b336d945d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Texas City Prairie Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4702 TX-146, Texas City, TX 77590, USA",
      "poi_short_description": "A 2,303-acre area of conserved bayside prairie, marshland & wetland teeming with birdlife.",
      "poi_long_description": "A 2,303-acre area of conserved bayside prairie, marshland & wetland teeming with birdlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-392e-704c-88fd-2330c28b25fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-392e-704c-88fd-2330c28b25fe",
        "storage_key": "property/6737460151192631/019e1dec-392e-704c-88fd-2330c28b25fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nature.org/en-us/get-involved/how-to-help/places-we-protect/texas-city-prairie-preserve/?en_txn1=bl.ch_tx.eg.x.g",
      "poi_directions_map_url": "https://maps.google.com/?cid=5447850314906040597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-city-prairie-preserve",
      "poi_latitude": "29.4452324",
      "poi_longitude": "-94.9432284",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 409-941-9114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-7627-712f-8fc1-68dd5b12cfa8",
        "storage_key": "property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8AbVeF7P4YRFXl5Wf-mmks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_1e860e83-8858-4a14-a93b-cd00b4f18714",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Nessler Park Family Aquatic Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1700 5th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "Clean water park for kids featuring a lazy river, slides, and a shallow pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-3bee-741e-9759-4f32ae1ebbe0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-3bee-741e-9759-4f32ae1ebbe0",
        "storage_key": "property/6737460151192631/019e1dec-3bee-741e-9759-4f32ae1ebbe0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texascitytx.gov/896/Nessler-Family-Aquatics-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=745463238714812079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nessler-park-family-aquatic-center",
      "poi_latitude": "29.3896635",
      "poi_longitude": "-94.9201505",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 409-643-5710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdzL53bt5P4YRr2a1sN1qWAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_c6a902dd-eb65-4e03-8385-826f28d39859",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Carver Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6415 Park Ave, Texas City, TX 77591, USA",
      "poi_short_description": "Park & community center offering baseball, softball & basketball, plus a fishing pond & playground.",
      "poi_long_description": "Park & community center offering baseball, softball & basketball, plus a fishing pond & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-39fe-760d-bdd0-c0b33ccc5d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-39fe-760d-bdd0-c0b33ccc5d47",
        "storage_key": "property/6737460151192631/019e1dec-39fe-760d-bdd0-c0b33ccc5d47.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.texascitytx.gov/Facilities/Facility/Details/Carver-Park-9",
      "poi_directions_map_url": "https://maps.google.com/?cid=2782523372427231232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carver-park",
      "poi_latitude": "29.3847712",
      "poi_longitude": "-94.9855554",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-229-1277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-7627-712f-8fc1-68dd5b12cfa8",
        "storage_key": "property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzaWCwM9-P4YRAEC_yEOCnSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_60669b07-c2df-4c76-bcc0-2e4e0f1903b5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Godard Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2110 25th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "Baseball facility offering a playground and baseball field along with a splash pad for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-3e0e-77d4-8ca8-1a34c63001fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-3e0e-77d4-8ca8-1a34c63001fd",
        "storage_key": "property/6737460151192631/019e1dec-3e0e-77d4-8ca8-1a34c63001fd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.texascitytx.gov/Facilities/Facility/Details/Godard-Park-18",
      "poi_directions_map_url": "https://maps.google.com/?cid=6661131269672725780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "godard-park",
      "poi_latitude": "29.408244",
      "poi_longitude": "-94.9272009",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-7627-712f-8fc1-68dd5b12cfa8",
        "storage_key": "property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkYE9FoV5P4YRFO0W-5gXcVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_908743e6-c3c2-48cf-8114-203eb06a7a40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Holland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S Humble Camp Rd, Dickinson, TX 77539, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.texascitytx.gov/Facilities/Facility/Details/Holland-Park-21",
      "poi_directions_map_url": "https://maps.google.com/?cid=2915955182927934296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holland-park",
      "poi_latitude": "29.4214376",
      "poi_longitude": "-94.9984887",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-7627-712f-8fc1-68dd5b12cfa8",
        "storage_key": "property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ50MsOh9P4YRWPNgG8qNdyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f43f5414-26f8-4dd7-9a6c-3aa7abb8ebdc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Mahan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Woodland St, La Marque, TX 77568, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=393545284300975503&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahan-park",
      "poi_latitude": "29.3505106",
      "poi_longitude": "-94.9838004",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-7627-712f-8fc1-68dd5b12cfa8",
        "storage_key": "property/6737460151192631/019e1dea-7627-712f-8fc1-68dd5b12cfa8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVRTZ_P4YRjy3K2VkndgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e2f01e7e-37a4-44b8-a75e-447ad0afddb2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Lagoonfest Texas",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12600 Crystal View Blvd, Texas City, TX 77568, USA",
      "poi_short_description": "Relaxed beach vibe destination featuring kayaking, paddleboarding, water slides and bumper boats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-49aa-734e-adcb-591c4016a892.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dea-49aa-734e-adcb-591c4016a892",
        "storage_key": "property/6737460151192631/019e1dea-49aa-734e-adcb-591c4016a892.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://lagoonfesttexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10550895170618331273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lagoonfest-texas",
      "poi_latitude": "29.4148875",
      "poi_longitude": "-95.051632",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-941-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8SDQp1_P4YRiRAXs0FPbJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_7a0dc842-492f-434c-92de-8729eed9ed03",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Davison Home At Heritage Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "109 3rd Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-3dd5-72ed-8d56-38b36b192d43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-3dd5-72ed-8d56-38b36b192d43",
        "storage_key": "property/6737460151192631/019e1dec-3dd5-72ed-8d56-38b36b192d43.webp",
        "width": 1280,
        "height": 1178
      },
      "poi_business_url": "https://www.texascitytx.gov/456/Historical-Homes",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091424466275461197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davison-home-at-heritage-square-park",
      "poi_latitude": "29.386746",
      "poi_longitude": "-94.8954116",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 409-229-1660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75b6-75ba-a13a-c2038d9448b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75b6-75ba-a13a-c2038d9448b1",
        "storage_key": "property/6737460151192631/019e1dea-75b6-75ba-a13a-c2038d9448b1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA9LFJdh5P4YRTejEcf_vMO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_88a09f4d-d176-47a4-9777-ffdb4808d3f8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Bay Area Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77058, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-3ff1-709e-bc37-a7d07465d231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-3ff1-709e-bc37-a7d07465d231",
        "storage_key": "property/6737460151192631/019e1dec-3ff1-709e-bc37-a7d07465d231.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6161951959593641744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-park--ride",
      "poi_latitude": "29.55289299999999",
      "poi_longitude": "-95.124069",
      "poi_miles_from_property": "17.4",
      "poi_walking_minutes": "6 hours 23 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGxOQR2CcQIYREOeZ6qimg1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_ca8c0523-8050-46c3-8647-d8211ce15dd7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "William P. Hobby Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7800 Airport Blvd, Houston, TX 77061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-4312-708f-b3e1-d2766027549a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-4312-708f-b3e1-d2766027549a",
        "storage_key": "property/6737460151192631/019e1dec-4312-708f-b3e1-d2766027549a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fly2houston.com/hou/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811035190079821913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-p-hobby-airport",
      "poi_latitude": "29.6459141",
      "poi_longitude": "-95.2768951",
      "poi_miles_from_property": "27.7",
      "poi_walking_minutes": "10 hours 11 mins",
      "poi_biking_minutes": "2 hours 8 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 713-640-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-5671-7118-a3b7-cd8deafc964e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-5671-7118-a3b7-cd8deafc964e",
        "storage_key": "property/6737460151192631/019e1dec-5671-7118-a3b7-cd8deafc964e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2ZP70-WQIYRWZj03jmDCJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_4d2bf1ec-aca0-4505-be14-b9f08d1be43e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Texas City Terminal Railway Co",
      "poi_type": "Transportation & Transit",
      "poi_address": "2425 TX-146, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-454c-769b-ab14-055a7427be99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-454c-769b-ab14-055a7427be99",
        "storage_key": "property/6737460151192631/019e1dec-454c-769b-ab14-055a7427be99.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tctrr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16979592315538435793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-city-terminal-railway-co",
      "poi_latitude": "29.4074458",
      "poi_longitude": "-94.9576557",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-945-4461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXVVNMl15P4YR0e6ezj-ho-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_fee30c3b-1dc0-4bba-96c8-1c37568cf7e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Texas City Dow",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3301 5th Ave S, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-4a7c-705a-a8a9-5359308d0619.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-4a7c-705a-a8a9-5359308d0619",
        "storage_key": "property/6737460151192631/019e1dec-4a7c-705a-a8a9-5359308d0619.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.dow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9863893623711388957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-city-dow",
      "poi_latitude": "29.379177",
      "poi_longitude": "-94.9448116",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-945-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7yKSpQR5P4YRHdWOV_2W44g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_f3966bb5-6caf-4c3b-a967-3556354a25d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Marathon - Galveston Bay Refinery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2401 5th Ave S, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-4d3e-70d9-889b-6b4a5fc5b7a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-4d3e-70d9-889b-6b4a5fc5b7a1",
        "storage_key": "property/6737460151192631/019e1dec-4d3e-70d9-889b-6b4a5fc5b7a1.webp",
        "width": 1280,
        "height": 525
      },
      "poi_business_url": "http://www.marathonpetroleum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5011288983010170761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marathon---galveston-bay-refinery",
      "poi_latitude": "29.3787692",
      "poi_longitude": "-94.9296724",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-943-7585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG4oM98t5P4YRiVcmc8esi0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_b6c650b1-1e1a-4fe5-900b-84ac231b8334",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Valero Texas City Refinery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 Loop 197 S, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-4b3f-7598-93ed-7797cd4872e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-4b3f-7598-93ed-7797cd4872e7",
        "storage_key": "property/6737460151192631/019e1dec-4b3f-7598-93ed-7797cd4872e7.webp",
        "width": 1200,
        "height": 766
      },
      "poi_business_url": "https://www.valero.com/about/locations/texas-city-refinery",
      "poi_directions_map_url": "https://maps.google.com/?cid=15277553274134837458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero-texas-city-refinery",
      "poi_latitude": "29.3690633",
      "poi_longitude": "-94.9131972",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 409-945-4451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_Gqvrx5P4YR0rjpRcLFBNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_e6f33708-07ac-4800-a879-dd29ad33b3f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "ExxonMobil Chemical CAB",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 Bayway Dr, Baytown, TX 77520, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-4d8d-75dd-9dc5-153adc104b39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-4d8d-75dd-9dc5-153adc104b39",
        "storage_key": "property/6737460151192631/019e1dec-4d8d-75dd-9dc5-153adc104b39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5060041911116299255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxonmobil-chemical-cab",
      "poi_latitude": "29.7409284",
      "poi_longitude": "-95.0246663",
      "poi_miles_from_property": "42.6",
      "poi_walking_minutes": "15 hours 38 mins",
      "poi_biking_minutes": "3 hours 33 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 281-834-0109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJocauPgZfP4YR9_usFE_hOEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_70d34cdd-f61c-4a0f-b079-f52e6de53fd1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Chevron Phillips Chemical Co - Cedar Bayou Plant",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9500 East Fwy, Baytown, TX 77521, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-4e6c-75ab-8eb9-d37d09aca1ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-4e6c-75ab-8eb9-d37d09aca1ac",
        "storage_key": "property/6737460151192631/019e1dec-4e6c-75ab-8eb9-d37d09aca1ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11971217925482847774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron-phillips-chemical-co---cedar-bayou-plant",
      "poi_latitude": "29.8217723",
      "poi_longitude": "-94.9232403",
      "poi_miles_from_property": "47.6",
      "poi_walking_minutes": "17 hours 30 mins",
      "poi_biking_minutes": "3 hours 58 mins",
      "poi_driving_minutes": "46 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf0jHsxFbP4YRHp4x6UZPIqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_8973d1ca-9ebe-4ae3-aac3-96231673d2e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Texas City Independent School",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Simpson Education Support Center, 1700 9th Ave N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-50ac-72cf-affb-4496b3af8f8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-50ac-72cf-affb-4496b3af8f8c",
        "storage_key": "property/6737460151192631/019e1dec-50ac-72cf-affb-4496b3af8f8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tcisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6683590847373588133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-city-independent-school",
      "poi_latitude": "29.394247",
      "poi_longitude": "-94.919754",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-916-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76e9-729e-a121-283594bff811",
        "storage_key": "property/6737460151192631/019e1dea-76e9-729e-a121-283594bff811.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7wtQJbx5P4YRpTbB6XbiwFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6f2fb93d-13a3-49cb-8ed9-f6b5f5b6deee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "3541 Palmer Hwy, Texas City, TX 77590, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Visitors praise this grocery store for its wide selection of fresh produce, good wine selection, and variety of items, including their inexpensive and tasty store-brand ice cream. They also highlight the spacious parking lot, clutter-free aisles, and excellent service from the staff.\n\nSome reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-15ec-77aa-8f6f-e0372862afd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-15ec-77aa-8f6f-e0372862afd6",
        "storage_key": "property/6737460151192631/019ea964-15ec-77aa-8f6f-e0372862afd6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/texas-city/texas-city/034/00108?cid=loc_03400108_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6100380171633196176&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.3934209",
      "poi_longitude": "-94.9493565",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 409-948-3471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76cf-7360-86b5-9772d4dce88f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76cf-7360-86b5-9772d4dce88f",
        "storage_key": "property/6737460151192631/019e1dea-76cf-7360-86b5-9772d4dce88f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbc6wJRN5P4YRkHwI5XHnqFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7d712c5f-dbd2-4693-8f22-247faeca1b4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "3442 Palmer Hwy, Texas City, TX 77590, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide variety of groceries, including organic products, and everything needed for daily life. They highlight the low prices and great deals, and the fresh produce. They also like the clean store and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-15ea-7559-8a3c-7ced2ec66059.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-15ea-7559-8a3c-7ced2ec66059",
        "storage_key": "property/6737460151192631/019ea964-15ea-7559-8a3c-7ced2ec66059.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/texas-city/3442-palmer-hwy/fa89",
      "poi_directions_map_url": "https://maps.google.com/?cid=8637253362995016553&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "29.39634599999999",
      "poi_longitude": "-94.948311",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76cf-7360-86b5-9772d4dce88f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76cf-7360-86b5-9772d4dce88f",
        "storage_key": "property/6737460151192631/019e1dea-76cf-7360-86b5-9772d4dce88f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo-t8aQp5P4YRabNd6Cuw3Xc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_5377cab4-0347-4ec7-9651-cd11ebf0fc7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Tanger Outlets Houston",
      "poi_type": "Shopping & Retail",
      "poi_address": "5885 Gulf Fwy, Texas City, TX 77591, USA",
      "poi_short_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_long_description": "Visitors say this outlet mall offers a wide selection of brand-name stores with great deals and discounted products. They also highlight the clean, well-maintained outdoor environment, ample parking, and spotless restrooms. Guests mention the friendly and helpful staff, along with a pleasant atmosphere for shopping and walking around.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-24d1-7210-8789-a34105d2caf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dea-24d1-7210-8789-a34105d2caf5",
        "storage_key": "property/6737460151192631/019e1dea-24d1-7210-8789-a34105d2caf5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.tangeroutlet.com/houston",
      "poi_directions_map_url": "https://maps.google.com/?cid=8122763437156308121&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tanger-outlets-houston",
      "poi_latitude": "29.42502189999999",
      "poi_longitude": "-95.0581191",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 281-534-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75a6-72a6-9e1f-dcb190e9d5c1",
        "storage_key": "property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpTa9bvh9P4YRmZQ7Uk_auXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b8f3420e-ffc6-4b1b-9bf8-affb85723c83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Baybrook Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_long_description": "Shoppers say this shopping center offers a diverse range of retail options, from high-end clothes stores to affordable boutiques, as well as a great food court with many choices. They also highlight the family-friendly atmosphere with a large outdoor area featuring a lawn, playground, and numerous restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-15a4-70a3-8bfb-4ca1292c854f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-15a4-70a3-8bfb-4ca1292c854f",
        "storage_key": "property/6737460151192631/019ea964-15a4-70a3-8bfb-4ca1292c854f.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.baybrookmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3962758813461213470&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "baybrook-mall",
      "poi_latitude": "29.5427508",
      "poi_longitude": "-95.148508",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 281-667-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75a6-72a6-9e1f-dcb190e9d5c1",
        "storage_key": "property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOf21c3qbQIYRHnHnLiWM_jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e044061d-4eb0-4722-b2f0-3cc6554e6576",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "League City Towne Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 Gulf Fwy S, League City, TX 77573, USA",
      "poi_short_description": "Shopping mall featuring a Target and several food options, plus ample parking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-1aea-7188-a4a9-d4b31e95eac2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-1aea-7188-a4a9-d4b31e95eac2",
        "storage_key": "property/6737460151192631/019ea964-1aea-7188-a4a9-d4b31e95eac2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=251646142781825913&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "league-city-towne-center",
      "poi_latitude": "29.4658523",
      "poi_longitude": "-95.086304",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 713-357-2180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75a6-72a6-9e1f-dcb190e9d5c1",
        "storage_key": "property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG_yjjPqCQIYReaObZdUGfgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8a35b3c0-bb33-45e8-8b6b-e82ae6c09728",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Victory Lakes Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "2860 Gulf Fwy S, League City, TX 77573, USA",
      "poi_short_description": "Strip mall with well-known retailers along heavily trafficked I-45 in League City.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-16b3-7622-abc8-41c191adb785.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-16b3-7622-abc8-41c191adb785",
        "storage_key": "property/6737460151192631/019ea964-16b3-7622-abc8-41c191adb785.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.frpltd.com/properties/victory-lakes-town-center/directory",
      "poi_directions_map_url": "https://maps.google.com/?cid=7533963573430826411&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "victory-lakes-town-center",
      "poi_latitude": "29.4701146",
      "poi_longitude": "-95.0911876",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 713-693-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75a6-72a6-9e1f-dcb190e9d5c1",
        "storage_key": "property/6737460151192631/019e1dea-75a6-72a6-9e1f-dcb190e9d5c1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg3ghffCCQIYRq7UTEfQDjmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e56d45c5-eecf-4748-8538-bae8dcd1dbc0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Buc-ee's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6201 Gulf Fwy, Texas City, TX 77591, USA",
      "poi_short_description": "Chain of convenience stores for snacks & drinks, plus eclectic themed T-shirts & knickknacks.",
      "poi_long_description": "People say this convenience store offers a wide variety of snacks, drinks, sandwiches, and jerky, as well as a bakery and souvenirs. They also highlight the clean restrooms, friendly staff, and fast check-outs.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-16fb-725b-985e-6e5c333b3b4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-16fb-725b-985e-6e5c333b3b4d",
        "storage_key": "property/6737460151192631/019ea964-16fb-725b-985e-6e5c333b3b4d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://buc-ees.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3160603657492895598&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "buc-ees",
      "poi_latitude": "29.428525",
      "poi_longitude": "-95.0632659",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 979-238-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-56a2-74f4-ae1b-24e21220b84a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-56a2-74f4-ae1b-24e21220b84a",
        "storage_key": "property/6737460151192631/019e1dec-56a2-74f4-ae1b-24e21220b84a.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJI7u57wiCQIYRbheq6Ee43Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_446f08f6-8c67-4624-a6b8-331cf2323e1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Cinemark",
      "poi_type": "Entertainment",
      "poi_address": "20915 Gulf Fwy, Webster, TX 77598",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3674ef9b-1705-4be1-910e-7175b97edc5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Altitude Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "10000 Emmett F Lowry Expy, Texas City, TX 77591, USA",
      "poi_short_description": "Amusement center at Mainland City Centre with trampolines and arcade games, plus foam parties.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-1aff-764a-aa6e-37d7e34d0db0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-1aff-764a-aa6e-37d7e34d0db0",
        "storage_key": "property/6737460151192631/019ea964-1aff-764a-aa6e-37d7e34d0db0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.texfunandsocial.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13873414773127196289&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "altitude-trampoline-park",
      "poi_latitude": "29.4063683",
      "poi_longitude": "-95.0253805",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 409-316-9335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRf18RXt-P4YRgS7nTTtFiMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_99921ff4-cb89-4a23-89e0-dbf8646279cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Tex Fun & Social Arcade",
      "poi_type": "Entertainment",
      "poi_address": "10000 Emmett F Lowry Expy #3161, Texas City, TX 77591",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d854f59-fcf3-4b79-94b9-8109d7028167",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Galveston Island Historic Pleasure Pier",
      "poi_type": "Entertainment",
      "poi_address": "2501 Seawall Blvd, Galveston, TX 77550, USA",
      "poi_short_description": "Old-fashioned waterfront amusement area with rides for all ages, games of skill & boardwalk eats.",
      "poi_long_description": "People say this amusement park offers fun rides, including a roller coaster, log ride, and swings, as well as carnival games and a Ferris wheel with ocean views. They also highlight the all-day pass provides good value, the atmosphere is family-friendly and relaxing, and the staff is friendly.\n\nOther reviews mention the entrance fee can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-2c6a-775d-848d-8b202e9845b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-2c6a-775d-848d-8b202e9845b0",
        "storage_key": "property/6737460151192631/019e1dec-2c6a-775d-848d-8b202e9845b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pleasurepier.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7014443759316874093&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "galveston-island-historic-pleasure-pier",
      "poi_latitude": "29.2875292",
      "poi_longitude": "-94.7902046",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 855-789-7437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPdkEDmCeP4YRbbMJW29PWGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a2f5fb97-983b-42a3-b89f-ed7f7473d99e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Space Center Houston",
      "poi_type": "Entertainment",
      "poi_address": "1601 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_long_description": "Visitors say this space center offers engaging exhibits, including real spacecraft, a Space Shuttle replica, and the massive Saturn V rocket. They also highlight the tram tours to the Historic Mission Control and astronaut training facilities as a must-do experience. Guests mention the staff are knowledgeable and friendly, and the center is well-organized and family-friendly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-189e-738b-ab9c-a9fddc3ee6b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-189e-738b-ab9c-a9fddc3ee6b4",
        "storage_key": "property/6737460151192631/019ea964-189e-738b-ab9c-a9fddc3ee6b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spacecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1436836062198888726&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "space-center-houston",
      "poi_latitude": "29.551832",
      "poi_longitude": "-95.0981044",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 281-244-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75b6-75ba-a13a-c2038d9448b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75b6-75ba-a13a-c2038d9448b1",
        "storage_key": "property/6737460151192631/019e1dea-75b6-75ba-a13a-c2038d9448b1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZlhwACdQIYRFvnVL8mq8BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f69cdb32-1b0d-4708-9d36-79b0489a8110",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Moody Gardens Attractions Theme Park",
      "poi_type": "Entertainment",
      "poi_address": "1 Hope Blvd, Galveston, TX 77554, USA",
      "poi_short_description": "242-acre amusement park with hotel & attractions including aquarium, zip line & paddlewheel boat.",
      "poi_long_description": "People say this attraction features impressive aquarium and rainforest pyramids with diverse marine life and free-roaming animals. Visitors highlight the engaging 3D and 4D theaters, as well as seasonal events like the stunning Ice Land sculptures. They also appreciate the friendly and helpful staff, along with convenient amenities like free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dec-302a-7269-93c3-8d25fbc9f95d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-302a-7269-93c3-8d25fbc9f95d",
        "storage_key": "property/6737460151192631/019e1dec-302a-7269-93c3-8d25fbc9f95d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.moodygardens.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=212891120115192546&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "moody-gardens-attractions-theme-park",
      "poi_latitude": "29.274746",
      "poi_longitude": "-94.8516919",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 409-744-4673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY47Vz1ecP4YR4hJNhlhX9AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_8e315c3a-cfc6-4e04-9a97-34e6b21b86be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Beyond Burger",
      "poi_type": "Restaurants",
      "poi_address": "10510 Emmett F Lowry Expy, Texas City, TX 77591, USA",
      "poi_short_description": "Sizable, laid-back option with arcade games for burgers & other American grub, plus milkshakes.",
      "poi_long_description": "Diners like this burger joint's delicious and fresh burgers, including Kobe and bison options, and appreciate the extensive self-serve toppings bar with various fresh ingredients. They also highlight the reasonable prices for the quality and generous portions, as well as the relaxed and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-1a9a-76e8-a73e-9489ac45d955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-1a9a-76e8-a73e-9489ac45d955",
        "storage_key": "property/6737460151192631/019ea964-1a9a-76e8-a73e-9489ac45d955.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.beyondburgertx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15275167670916600047&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "beyond-burger",
      "poi_latitude": "29.4040985",
      "poi_longitude": "-95.0261596",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 409-986-7832",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp1_vKWV-P4YR79CDvRBM_NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_f74171c1-62ca-4c6c-a5bc-11ace73cd45c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Gringo’s Mexican Kitchen {Texas City}",
      "poi_type": "Restaurants",
      "poi_address": "10200 EF, 10200 Emmett F Lowry Expy, Texas City, TX 77591, USA",
      "poi_short_description": "Laid-back chain outpost dishing up Tex-Mex classics & cocktails in informal digs.",
      "poi_long_description": "Diners praise the flavorful fajitas, delicious enchiladas, and addictive green sauce offered at this Tex-Mex restaurant. The staff are consistently described as friendly and professional.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-23bb-778a-a390-bcd9cad128d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-23bb-778a-a390-bcd9cad128d5",
        "storage_key": "property/6737460151192631/019ea964-23bb-778a-a390-bcd9cad128d5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.gringostexmex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18273751795762404709&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gringos-mexican-kitchen-texas-city",
      "poi_latitude": "29.4033315",
      "poi_longitude": "-95.0233133",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 409-986-6864",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJicM7XmN-P4YRZR0TlHBomf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_b7c9d0b1-b013-4a95-890b-60198f166821",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "2411 Palmer Hwy, Texas City, TX 77590, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Diners consistently praise this fast-food restaurant for its delicious food, particularly the chicken sandwich and breakfast items. The friendly and courteous staff are also frequently mentioned as a positive aspect of the dining experience.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-1dab-7512-a289-9b36680938dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-1dab-7512-a289-9b36680938dc",
        "storage_key": "property/6737460151192631/019ea964-1dab-7512-a289-9b36680938dc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.whataburger.com/tx/texas-city/2411-palmer-hwy.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=2325964211448507968&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "29.3944388",
      "poi_longitude": "-94.930042",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 409-948-3153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6SA5hKF5P4YRQO6odyB8RyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_62df4978-26e6-4e93-b2ba-55697569f194",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Salad and Go",
      "poi_type": "Restaurants",
      "poi_address": "3011 FM1764, La Marque, TX 77568",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5955371744404906679&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "2801-fm-2004",
      "poi_latitude": "29.409460700000004",
      "poi_longitude": "-95.0332007",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-jAXXF-P4YRtyKncgy7pVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_30520fc1-0d44-4ff2-bda3-70c29c277c98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Chipotle",
      "poi_type": "Restaurants",
      "poi_address": "2901 FM1764, La Marque, TX 77568",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5955371744404906679&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "2801-fm-2004",
      "poi_latitude": "29.409460700000004",
      "poi_longitude": "-95.0332007",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-jAXXF-P4YRtyKncgy7pVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_794cc6fb-03f2-4b2a-ba80-73969368933e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "3001 FM1764, La Marque, TX 77568, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners like this restaurant's consistently good and juicy chicken tenders, Cane's sauce, and grilled toast, with many noting the food is often hot and fresh. They also highlight the fast, friendly service, and the clean, cheerful atmosphere.\n\nSome reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-1ecb-76ff-950e-380f79b0bf36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-1ecb-76ff-950e-380f79b0bf36",
        "storage_key": "property/6737460151192631/019ea964-1ecb-76ff-950e-380f79b0bf36.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/la-marque/3001-fm-1764",
      "poi_directions_map_url": "https://maps.google.com/?cid=2496644242310053705&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "29.4001947",
      "poi_longitude": "-95.0352221",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 254-523-3994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-75ad-745f-96d4-3ddb798751dc",
        "storage_key": "property/6737460151192631/019e1dea-75ad-745f-96d4-3ddb798751dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRVxToWp_P4YRST9q6bXcpSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1a6bd584-8397-4fbe-acef-780b5ba7a276",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "The Basemint Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5885 Gulf Fwy #910, Texas City, TX 77591, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea964-1e12-7015-bc02-dad5624fbb0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea964-1e12-7015-bc02-dad5624fbb0b",
        "storage_key": "property/6737460151192631/019ea964-1e12-7015-bc02-dad5624fbb0b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16266593311334326112&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-basemint-training-center",
      "poi_latitude": "29.4244431",
      "poi_longitude": "-95.0574088",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOfIjtVh-P4YRYN_Tu26MvuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2609fe2c-a312-4b6c-8b5d-e5913fc3afb0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "UTMB Health League City Campus Hospital & Clinics",
      "poi_type": "Health and Wellness",
      "poi_address": "2240 Gulf Fwy S, League City, TX 77573, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea965-1d64-7358-81cf-89be6cf1fc21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea965-1d64-7358-81cf-89be6cf1fc21",
        "storage_key": "property/6737460151192631/019ea965-1d64-7358-81cf-89be6cf1fc21.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.utmbhealth.com/lcc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11280674435717029507&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "utmb-health-league-city-campus-hospital--clinics",
      "poi_latitude": "29.481445",
      "poi_longitude": "-95.098429",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 409-772-1011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76c1-746b-bc61-c6c0c58cbd74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76c1-746b-bc61-c6c0c58cbd74",
        "storage_key": "property/6737460151192631/019e1dea-76c1-746b-bc61-c6c0c58cbd74.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4yESOCCQIYRg16-t6EBjZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_d961d339-412d-481c-a081-c553ecdaf3e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "poi_name": "Halfmoon Shoal Lighthouse",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "001 Skyline Dr, Texas City, TX 77590, USA",
      "poi_short_description": "Peaceful landmark offering scenic views of the skyline and dike.",
      "poi_long_description": "Visitors say this lighthouse replica offers amazing views, especially at sunset and during a full moon, and provides great historical information. They also highlight that it's a nice stop on a walk around the trails. Others mention it's free to visit during the week, but there's a dike fee on weekends and bank holidays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019ea965-1dbc-77b8-b09a-71c30f8a377d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea965-1dbc-77b8-b09a-71c30f8a377d",
        "storage_key": "property/6737460151192631/019ea965-1dbc-77b8-b09a-71c30f8a377d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lighthousefriends.com/light.asp?ID=1796",
      "poi_directions_map_url": "https://maps.google.com/?cid=7028097248382967126&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "halfmoon-shoal-lighthouse",
      "poi_latitude": "29.3983419",
      "poi_longitude": "-94.8884895",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 409-948-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dea-76d7-73bf-a2b1-69d9052e445a",
        "storage_key": "property/6737460151192631/019e1dea-76d7-73bf-a2b1-69d9052e445a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdtFAF53P4YRVl3EADbRiGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    }
  ],
  "office_hours": [
    {
      "id": "ec_313cef72a096b9cd60eaf058",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a5e83360ecb999e9b6f10ae6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d097baf4d7288e7268e5e9fd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0bd9822a30a02974b038db93",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7fbf7426688d51b8c7d5df60",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_07d89c8291b6f3ccda30bdd8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_f2fce354-cd4a-41ca-9536-5ab4907cdff3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "rating": "5",
      "name": "Quinn Hall",
      "text": "I lived here for roughly 3 years back in 2015-17, It was great. Just know that there isn’t too much to do in the immediate area. The place is quiet and they keep up the property well. I hope I can find a similar place where I’m moving. Move to the 2nd floor or higher to opt out of the occasional flooding",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_c51fa26e-f54f-4aaa-bef9-05953d99326b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "rating": "5",
      "name": "Austin G",
      "text": "I toured Windsor Estates with Mariah and she made everything easy… I mean it. The tour was nice, she explained everything clearly, and she answered all my questions without making me feel rushed. Super patient and genuine. You can tell she cares about people, not just closing a lease.",
      "date": "2026-04-03",
      "title": "false"
    },
    {
      "id": "custom_55366d02-a2f2-4852-bc98-80e8b4a32145",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "rating": "5",
      "name": "Enrique Reyes",
      "text": "Nice employees and great atmosphere",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_9b746de9-db01-4798-9604-e0183322c50d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "rating": "5",
      "name": "Jonai Cirilo",
      "text": "Listen… if you go to Windsor Estates, ask for Mariah. She told me she’s new but you would NOT be able to tell. Super professional, real sweet, and actually knows what she’s talking about. She made me feel comfortable the whole time and didn’t give that pushy leasing vibe at all. 10/10 experience fr.",
      "date": "2026-03-27",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e38b28f4-d076-47a4-a86d-189ce62da681",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019e678b-7553-75ec-aefc-80146c855c40.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e678b-7553-75ec-aefc-80146c855c40",
        "storage_key": "property/6737460151192631/019e678b-7553-75ec-aefc-80146c855c40.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=68bf7705fbe51e4bc4560cb7"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01996471-bb3e-778d-b6ca-2d6904aa563a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-windsor-estates-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631"
    },
    {
      "lead_collector_id": "019a5030-9919-71cb-ae19-9f5fec43c2fd",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-windsor-estates-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-texas-city",
      "search_query": "apartments with in-unit laundry Texas City",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Texas City",
      "h2_subtitle": "Discover comfort at Windsor Estates with in-unit laundry amenities. Enjoy more time for yourself in a convenient Texas City location.",
      "page_copy": "Experience the best of Texas City living at Windsor Estates, where each apartment is designed with your lifestyle in mind, including the sought-after feature of in-unit laundry. Say goodbye to the inconveniences of shared laundry facilities and enjoy the comfort and privacy of your own space. Choose from our spacious one, two, and three-bedroom options, each offering modern amenities that cater to your every need. \n\nNestled in the heart of South Galveston County, Windsor Estates boasts a host of features beyond just in-unit laundry. Dive into our refreshing pool or take a break in our contemporary clubhouse. With high-speed internet access, staying connected is a breeze, and our fitness center is perfect for maintaining an active lifestyle. Explore our availability today and find the perfect home that combines convenience and comfort with prime access to all Texas City has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
      "featured_image_media": {
        "alt_text": "Living room with dining area and TV.",
        "public_id": "019d0784-5429-7029-8b97-18d5eac4224d",
        "storage_key": "property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Texas City",
      "seo_description": "Find comfort at Windsor Estates! Enjoy in-unit laundry and more in Texas City. Browse our one, two, and three-bedroom apartments today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "generator",
      "page_item_url": "dog-park-apartments-galveston-county",
      "search_query": "dog park apartments Galveston County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Galveston County",
      "h2_subtitle": "Windsor Estates offers pet-friendly living with a dog park right in the community. Perfect for pet owners in Galveston County.",
      "page_copy": "Nestled in the vibrant community of Texas City, Windsor Estates is the ideal home for pet lovers searching for dog park apartments in Galveston County. Our pet-friendly property features a convenient dog park that allows your furry friends to play and socialize in a safe environment, providing the perfect retreat for both residents and their pets. Choose from our spacious one, two, or three-bedroom layouts, all designed with your comfort in mind.\n\nBeyond our dedicated dog park, Windsor Estates offers a comprehensive range of amenities guaranteed to enhance your living experience. Unwind at our modern clubhouse, keep fit in our state-of-the-art fitness center, or simply relax by the pool. With high-speed internet access available throughout the property, you can stay connected from anywhere. See why Windsor Estates is the ultimate location for both you and your pet by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
      "featured_image_media": {
        "alt_text": "Living room with dining area and TV.",
        "public_id": "019d0784-5429-7029-8b97-18d5eac4224d",
        "storage_key": "property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Galveston County",
      "seo_description": "Windsor Estates in Galveston County offers pet-friendly apartments with a dog park. Discover your new home in Texas City today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-77591",
      "search_query": "air conditioned apartments near 77591",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near 77591",
      "h2_subtitle": "Stay cool at Windsor Estates, offering air-conditioned apartments near 77591. Experience comfort and convenience in Texas City.",
      "page_copy": "Discover a cool and comfortable living experience at Windsor Estates, offering air-conditioned apartments near the 77591 area. Our community provides the perfect combination of luxury and convenience in the heart of Texas City, helping you beat the Texas heat effortlessly. Choose from a variety of well-appointed one, two, or three-bedroom floor plans, each equipped with modern amenities to complement your lifestyle.\n\nBeyond the comfort of indoor air conditioning, Windsor Estates is rich with features to enhance your day-to-day living. Enjoy our inviting pool, stay connected with high-speed internet access, and take advantage of our contemporary clubhouse and conference rooms for work or relaxation. Our community location also offers easy access to the best of Galveston County, ensuring you're never far from shopping, dining, and entertainment. Visit us today and find out how you can call Windsor Estates your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
      "featured_image_media": {
        "alt_text": "Living room with dining area and TV.",
        "public_id": "019d0784-5429-7029-8b97-18d5eac4224d",
        "storage_key": "property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near 77591",
      "seo_description": "Windsor Estates offers air-conditioned apartments near 77591 in Texas City. Enjoy a comfortable lifestyle with modern amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "generator",
      "page_item_url": "apartments-with-pool-texas-city",
      "search_query": "apartments with pool Texas City",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Texas City",
      "h2_subtitle": "Relax at Windsor Estates, where you can enjoy a refreshing pool in the heart of Texas City. Discover luxury living today.",
      "page_copy": "Take a dive into relaxed living at Windsor Estates, where our apartments with a pool serve as the ultimate oasis in Texas City. Our resort-style swimming pool is perfect for those sunny Texas days, allowing residents to unwind, socialize, or simply soak up the sun in a beautifully landscaped setting. Choose from our spacious one, two, or three-bedroom apartment options, each designed with a blend of comfort and modern style.\n\nWindsor Estates is committed to providing a superior living experience beyond just our sparkling pool. Our array of amenities includes a fitness center, high-speed internet access, and a welcoming clubhouse perfect for gatherings. Situated in a prime location in South Galveston County, Windsor Estates offers easy access to all the area has to offer, ensuring you have everything you need at your fingertips. Visit today to see why our community is the premier choice for apartments with a pool in Texas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
      "featured_image_media": {
        "alt_text": "Living room with dining area and TV.",
        "public_id": "019d0784-5429-7029-8b97-18d5eac4224d",
        "storage_key": "property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Texas City",
      "seo_description": "Enjoy resort-style living at Windsor Estates with a refreshing pool. Discover the best apartments in Texas City today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-south-galveston-county",
      "search_query": "apartments with fitness center in South Galveston County",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Galveston Co.",
      "h2_subtitle": "Windsor Estates offers top-notch apartments with a fitness center in South Galveston County. Experience premium amenities today.",
      "page_copy": "Embrace an active lifestyle at Windsor Estates, your prime destination for apartments with a fitness center in South Galveston County. Our well-equipped fitness center allows residents to stay fit and healthy without the need for an external gym membership. With a variety of exercise equipment available, your workout routine can be as varied as you like. Choose from our selection of spacious floor plans, including one, two, and three-bedroom apartments, designed with modern features and finishes.\n\nAside from our dedicated fitness center, Windsor Estates offers a multitude of amenities designed to enhance your living experience. Take advantage of our high-speed internet access, relax by the pool, or host an event in our elegant clubhouse. Located conveniently in Texas City, within South Galveston County, our community provides easy access to local attractions, shopping, and dining. Come tour Windsor Estates today and see why our apartments with a fitness center are the perfect choice for active individuals.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
      "featured_image_media": {
        "alt_text": "Living room with dining area and TV.",
        "public_id": "019d0784-5429-7029-8b97-18d5eac4224d",
        "storage_key": "property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Galveston Co.",
      "seo_description": "Stay active at Windsor Estates with our fitness center. Ideal apartments in South Galveston County offering modern living and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-galveston-county",
      "search_query": "one bedroom apartments near South Galveston County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near South Galveston Co.",
      "h2_subtitle": "Explore Windsor Estates' cozy one-bedroom apartments near South Galveston County. Experience comfort and convenience in Texas City.",
      "page_copy": "Discover the charm of Windsor Estates, offering cozy one-bedroom apartments near South Galveston County. Our thoughtfully designed units provide the ideal blend of comfort and style, perfect for individuals or couples seeking a desirable living space in Texas City. Each apartment is equipped with modern amenities, ensuring a convenient lifestyle.\n\nWindsor Estates boasts an array of community features, including a sparkling pool, a fully-equipped fitness center, and a welcoming clubhouse. Our prime location in South Galveston County means you're close to all the local attractions, dining, and entertainment options the area has to offer. Whether you're looking to explore or unwind, Windsor Estates provides a peaceful retreat with excellent accessibility. Schedule a visit today and see why our one-bedroom apartments are the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
      "featured_image_media": {
        "alt_text": "Living room with dining area and TV.",
        "public_id": "019d0784-5429-7029-8b97-18d5eac4224d",
        "storage_key": "property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apts Near South Galveston County",
      "seo_description": "Find comfort in Windsor Estates' one-bedroom apartments near South Galveston County. Enjoy modern amenities in a prime Texas City location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-texas-city",
      "search_query": "two bedroom apartments Texas City",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Texas City",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Windsor Estates in Texas City. Enjoy contemporary living with top amenities.",
      "page_copy": "Experience the ideal balance of space and style at Windsor Estates, featuring two-bedroom apartments in Texas City designed to cater to various lifestyles. Our thoughtfully crafted floor plans ensure ample living space, coupled with modern conveniences for a comfortable home life. Perfect for roommates, small families, or those needing a home office space, our two-bedroom units are versatile and inviting.\n\nIn addition to spacious living quarters, Windsor Estates offers a myriad of amenities that enhance your living experience. Dive into relaxation at our refreshing pool, stay healthy in our well-equipped fitness center, or host friends in our elegant clubhouse. Located conveniently in the vibrant community of South Galveston County, residents enjoy easy access to local hotspots, dining, and entertainment. Visit Windsor Estates today, and see why our two-bedroom apartments in Texas City are the perfect place to live and thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
      "featured_image_media": {
        "alt_text": "Living room with dining area and TV.",
        "public_id": "019d0784-5429-7029-8b97-18d5eac4224d",
        "storage_key": "property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Texas City",
      "seo_description": "Explore Windsor Estates' two-bedroom apartments in Texas City. Offering spacious living with modern amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192631",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-galveston-county",
      "search_query": "three bedroom apartments in Galveston County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Galveston County",
      "h2_subtitle": "Check out the spacious three-bedroom apartments at Windsor Estates in Galveston County. Enjoy a blend of comfort and convenience.",
      "page_copy": "Windsor Estates invites you to explore our expansive three-bedroom apartments in Galveston County. Designed for families or those needing extra space, these well-appointed units offer both comfort and functionality. Each apartment integrates modern living necessities with stylish design, providing an ideal backdrop for creating memories.\n\nBeyond the confines of your apartment, Windsor Estates delivers unmatched amenities, including a sparkling pool, a state-of-the-art fitness center, and versatile conference rooms. Nestled in the heart of South Galveston County, our community offers easy access to a variety of local attractions, shopping, and dining options. Enjoy the vibrant surroundings and take advantage of our incredible amenities, making Windsor Estates the perfect place for you and your loved ones. Stop by for a tour today and see our three-bedroom apartments firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
      "featured_image_media": {
        "alt_text": "Living room with dining area and TV.",
        "public_id": "019d0784-5429-7029-8b97-18d5eac4224d",
        "storage_key": "property/6737460151192631/019d0784-5429-7029-8b97-18d5eac4224d.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Galveston County",
      "seo_description": "Discover spacious three-bedroom apartments at Windsor Estates in Galveston County. Experience modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3419"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483353"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4709057"
    },
    {
      "ID": "custom_best_of_logo",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WK3L3PMP"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "409-377-8128"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "409-377-6969"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "409-377-6871"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "409-377-6943"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "409-377-6805"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "409-377-6783"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "409-377-8288"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "409-345-2079"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "409-377-6931"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "409-405-4726"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "409-403-2082"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "409-345-2067"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "409-215-0580"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "409-547-7019"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "409-994-6138"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "409-345-2936"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "409-405-6057"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "409-746-5437"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321132575"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "409-377-8206"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "409-254-4822"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "11ee19570b2c16d4"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "409-908-3639"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "409-377-8087"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "409-405-6039"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "409-377-8090"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "409-377-8233"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "409-345-2075"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "409-377-8104"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.windsorestatesapthome.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192631/019e8497-8603-7716-a71a-3de4db484012.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "409-345-2090"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "409-405-4726"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3419",
  "custom_repli_id": "5028483353",
  "custom_realpage_id": "4709057",
  "custom_best_of_logo": "true",
  "custom_knock_a_link": "https://www.windsorestatesapthome.com?utm_knock=a",
  "custom_knock_g_link": "https://www.windsorestatesapthome.com?utm_knock=g",
  "custom_knock_r_link": "https://www.windsorestatesapthome.com?utm_knock=r",
  "custom_knock_w_link": "https://www.windsorestatesapthome.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-WK3L3PMP",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.windsorestatesapthome.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.windsorestatesapthome.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.windsorestatesapthome.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.windsorestatesapthome.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.windsorestatesapthome.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.windsorestatesapthome.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "409-377-8128",
  "custom_knock_ads_link": "https://www.windsorestatesapthome.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.windsorestatesapthome.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "409-377-6969",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.windsorestatesapthome.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.windsorestatesapthome.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.windsorestatesapthome.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.windsorestatesapthome.com?utm_knock=psa",
  "custom_knock_r_number": "409-377-6871",
  "custom_knock_w_number": "409-377-6943",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "409-377-6805",
  "custom_knock_amap_link": "https://www.windsorestatesapthome.com?utm_knock=amap",
  "custom_knock_ar_number": "409-377-6783",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "409-377-8288",
  "custom_knock_fb_number": "409-345-2079",
  "custom_knock_fl_number": "409-377-6931",
  "custom_knock_gp_number": "409-405-4726",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.windsorestatesapthome.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "409-403-2082",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.windsorestatesapthome.com?utm_knock=bcard",
  "custom_knock_bnr_number": "409-345-2067",
  "custom_knock_cfres_link": "https://www.windsorestatesapthome.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "409-215-0580",
  "custom_knock_lgp_number": "409-547-7019",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.windsorestatesapthome.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "409-994-6138",
  "custom_knock_psa_number": "409-345-2936",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "409-405-6057",
  "custom_knock_bandit_link": "https://www.windsorestatesapthome.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.windsorestatesapthome.com?utm_knock=flyers",
  "custom_knock_osoc_number": "409-746-5437",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321132575",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "409-377-8206",
  "custom_knock_cfres_number": "409-254-4822",
  "custom_knock_chatgpt_link": "https://www.windsorestatesapthome.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "11ee19570b2c16d4",
  "custom_knock_dirmail_link": "https://www.windsorestatesapthome.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "409-908-3639",
  "custom_knock_propbro_link": "https://www.windsorestatesapthome.com?utm_knock=propbro",
  "custom_knock_bandit_number": "409-377-8087",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "409-405-6039",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.windsorestatesapthome.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "409-377-8090",
  "custom_knock_dirmail_number": "409-377-8233",
  "custom_knock_propbro_number": "409-345-2075",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "409-377-8104",
  "custom_knock_maintenance_link": "https://www.windsorestatesapthome.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192631/019e8497-8603-7716-a71a-3de4db484012.mp4",
  "custom_knock_maintenance_number": "409-345-2090",
  "custom_ppc_tracking_phone_number": "409-405-4726"
};

export const generatedAt = '2026-10-07T17:12:38.997Z';
